import React, { useEffect, useState, useRef } from "react";
import Header from "../Components/Header";
import SimilarProducts from "../DetailsExtra/SimilarProducts";
import DetailsTab from "../DetailsExtra/DetailsTab";
import MiddleImage from "../DetailsExtra/MiddleImage";
import DetailsSizes from "../DetailsExtra/DetailsSizes";
import VerticalSlider from "../DetailsExtra/VerticalSlider";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Description from "../DetailsTabs/Description";
import Designs from "../DetailsTabs/Designs";
import Colors from "../DetailsTabs/Colors";
import Pickup from "../DetailsTabs/Pickup";
import SizeTable from "../DetailsTabs/SizeTable";
import Shipping from "../DetailsTabs/Shipping";
import Inspire from "../DetailsTabs/Inspire";
import Cookies from "js-cookie";
import store from "../../Store/Cart.js";
import {
  get_glbFile,
  getCart,
  productDetails,
  productStyle_Api,
  submitReview,
} from "../../Services/Operations/ProductAPI";
import {
  deleteProductRow,
  removeCart,
  setProductOrderType,
  updateProductRow,
} from "../../Redux/Cart_System";
import "../../Styles/Details.css";
import {
  addCart,
  addFavorite,
  addProductRow,
  removeFavorite,
  updateCartQuantity,
  addProductCustomization,
  addProductColorCustomization,
} from "../../Redux/Cart_System";
import "../../Styles/Details.css";
import { addToCart, stockCheck } from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaRulerCombined } from "react-icons/fa";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { useParams } from "react-router-dom";
import Footer from "../Components/Footer.jsx";
import MoblieVertical from "../DetailsExtra/MoblieVertical.jsx";
import { RiDeleteBin5Line } from "react-icons/ri";
import { MdAdd } from "react-icons/md";
import {
  updateTempProductRow,
  removeTempProductRow,
} from "../../Redux/Cart_System";
import { keyframes } from "framer-motion";
import Slider from "react-slick";
import { baseURL } from "../../Services/api_endpoints.js";

const SkeletonLoader = () => {
  return (
    <div>
      <div style={{ height: "56px" }}></div>
      <main className="content-main">
        <div className="container">
          <div className="container-main">
            <div className="product-detail">
              <div className="product-detail-content bgweb">
                <div
                  className="row product-detail-main block-container-2"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                  }}
                >
                  <div className="skeleton-vertical-slider">
                    {[...Array(4)].map((_, i) => (
                      <div key={i} className="skeleton-thumbnail"></div>
                    ))}
                  </div>

                  <div className="skeleton-main-image"></div>

                  <div className="skeleton-details">
                    <div className="skeleton-title"></div>
                    <div className="skeleton-price"></div>
                    <div className="skeleton-color"></div>
                    <div className="skeleton-sizes">
                      {[...Array(5)].map((_, i) => (
                        <div key={i} className="skeleton-size"></div>
                      ))}
                    </div>
                    <div className="skeleton-button"></div>
                  </div>
                </div>

                <div className="skeleton-tabs">
                  <div className="skeleton-tab-header"></div>
                  <div className="skeleton-tab-content"></div>
                </div>

                <div className="skeleton-similar">
                  <div className="skeleton-section-title"></div>
                  <div className="skeleton-products-grid">
                    {[...Array(4)].map((_, i) => (
                      <div key={i} className="skeleton-product-card">
                        <div className="skeleton-product-image"></div>
                        <div className="skeleton-product-info"></div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <style jsx>{`
          .skeleton-vertical-slider {
            width: 80px;
            display: flex;
            flex-direction: column;
            gap: 10px;
          }

          .skeleton-thumbnail {
            width: 80px;
            height: 80px;
            background: #e0e0e0;
            border-radius: 4px;
            animation: pulse 1.5s infinite ease-in-out;
          }

          .skeleton-main-image {
            width: 400px;
            height: 400px;
            background: #e0e0e0;
            border-radius: 4px;
            animation: pulse 1.5s infinite ease-in-out;
          }

          .skeleton-details {
            width: 300px;
            display: flex;
            flex-direction: column;
            gap: 15px;
          }

          .skeleton-title {
            height: 28px;
            width: 80%;
            background: #e0e0e0;
            border-radius: 4px;
            animation: pulse 1.5s infinite ease-in-out;
          }

          .skeleton-price {
            height: 24px;
            width: 60%;
            background: #e0e0e0;
            border-radius: 4px;
            animation: pulse 1.5s infinite ease-in-out;
          }

          .skeleton-color {
            height: 20px;
            width: 40%;
            background: #e0e0e0;
            border-radius: 4px;
            animation: pulse 1.5s infinite ease-in-out;
          }

          .skeleton-sizes {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            margin: 10px 0;
          }

          .skeleton-size {
            width: 50px;
            height: 40px;
            background: #e0e0e0;
            border-radius: 4px;
            animation: pulse 1.5s infinite ease-in-out;
          }

          .skeleton-button {
            height: 48px;
            width: 100%;
            background: #e0e0e0;
            border-radius: 4px;
            animation: pulse 1.5s infinite ease-in-out;
            margin-top: 20px;
          }

          .skeleton-tabs {
            margin-top: 40px;
          }

          .skeleton-tab-header {
            height: 40px;
            width: 100%;
            background: #e0e0e0;
            border-radius: 4px;
            animation: pulse 1.5s infinite ease-in-out;
            margin-bottom: 15px;
          }

          .skeleton-tab-content {
            height: 200px;
            width: 100%;
            background: #e0e0e0;
            border-radius: 4px;
            animation: pulse 1.5s infinite ease-in-out;
          }

          .skeleton-similar {
            margin-top: 60px;
          }

          .skeleton-section-title {
            height: 32px;
            width: 40%;
            background: #e0e0e0;
            border-radius: 4px;
            animation: pulse 1.5s infinite ease-in-out;
            margin-bottom: 30px;
          }

          .skeleton-products-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 20px;
          }

          .skeleton-product-card {
            display: flex;
            flex-direction: column;
            gap: 10px;
          }

          .skeleton-product-image {
            width: 100%;
            height: 200px;
            background: #e0e0e0;
            border-radius: 4px;
            animation: pulse 1.5s infinite ease-in-out;
          }

          .skeleton-product-info {
            height: 60px;
            width: 100%;
            background: #e0e0e0;
            border-radius: 4px;
            animation: pulse 1.5s infinite ease-in-out;
          }

          @keyframes pulse {
            0% {
              opacity: 0.6;
            }
            50% {
              opacity: 1;
            }
            100% {
              opacity: 0.6;
            }
          }
        `}</style>
      </main>
    </div>
  );
};

const NextArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    style={{
      position: "absolute",
      top: "50%",
      right: "10px",
      transform: "translateY(-50%)",
      backgroundColor: "rgba(255, 255, 255, 0.7)",
      border: "none",
      borderRadius: "50%",
      width: "40px",
      height: "40px",
      cursor: "pointer",
      fontSize: "20px",
      textAlign: "center",
      zIndex: 1,
    }}
  >
    &#10095;
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    style={{
      position: "absolute",
      top: "50%",
      left: "10px",
      transform: "translateY(-50%)",
      backgroundColor: "rgba(255, 255, 255, 0.7)",
      border: "none",
      borderRadius: "50%",
      width: "40px",
      height: "40px",
      cursor: "pointer",
      fontSize: "20px",
      textAlign: "center",
      zIndex: 1,
    }}
  >
    &#10094;
  </button>
);

function DetailsPage() {
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(0);

  const [mobile,setMobile]=useState(window.innerWidth<567?true:false)

  const [localQuantity, setLocalQuantity] = useState(0);
  const cartItemsFromRedux = useSelector((state) => state.cart.items);
  const productItems = useSelector((state) => state.cart.productItems);
  console.log("productItems : ", productItems);
  const totalItems = useSelector((state) => state.cart.totalItems);
  const [cartItems, setCartItems] = useState(cartItemsFromRedux);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const fromEventPage = location.state?.fromEventPage || false;
  const [product, setproduct] = useState(0);
  const [selectedImage, setSelectedImage] = useState(product?.image);
  const [orderType, setOrderType] = useState("normal");
  const [isTeamModalOpen, setIsTeamModalOpen] = useState(false);
  const [isFamilyModalOpen, setIsFamilyModalOpen] = useState(false);
  const [teamName, setTeamName] = useState("");
  const [teamMembers, setTeamMembers] = useState(1);
  const [familyName, setFamilyName] = useState("");
  const [familyMembers, setFamilyMembers] = useState(1);
  const [includePetNames, setIncludePetNames] = useState(false);


  console.log("product : ", product);
  const[fromTeam,setFromTeam]=useState(false)
  const[rateMode,setRateMode]=useState(true)

  // const dispatch = useDispatch();
  // const cartItems = useSelector((state) => state.cart.items);
  //console.log("product in detailsSize : ", product);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedSizeId, setSelectedSizeId] = useState(null);
  const [selectedPrice, setSelectedPrice] = useState("");
  const [cartId, setCartId] = useState("");
  const queryParams = new URLSearchParams(location.search);
  //console.log("cartItems row : ", cartItems);
  const { tokenDetails } = useSelector((state) => state.user);
  const cart=useSelector((state)=>state.cart)
  //console.log("token details in product listinging : ", tokenDetails);
  const navigate = useNavigate();
  const favorites = useSelector((state) => state.cart.favorites);

  const isFavorite = favorites.some((item) => item.id === product.id);

  const [loading, setLoading] = useState(false);
  console.log("productItems: ", productItems);

  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedColorName, setSelectedColorName] = useState(null);
  const productInCart = useSelector((state) =>
    state.cart.productItems.find((item) => item.product_id === product.id)
  );
  const [suggestion, setSuggestion] = useState("");
  //console.log("product in middle page : ", product);
  const [selectedOptions, setSelectedOptions] = useState([]);
  // const [options, setOptions] = useState([]);
  const [sponsorName, setSponsorName] = useState("");
  const [specialRequests, setSpecialRequests] = useState("");
  const [logoFile, setLogoFile] = useState(null);
  const [isOpen, setIsOpen] = useState(false); // Add missing dropdown state
  const[logoOpen,setLogoOpen]=useState(false)
  const[teamNameOpen,setTeamNameOpenOpen]=useState(false)
  const[numberOpen,setNumberOpen]=useState(false)
  // Initialize with color from Redux if exists
  const { productSlug } = useParams();
    const { isTeam } = useParams();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [sizeAll, setSize] = useState([]);
  const [rating,setRating]=useState([])

  const [activeTab, setActiveTab] = useState("description");

  const [showLens, setShowLens] = useState(false);
  const [lensPosition, setLensPosition] = useState({ x: 0, y: 0 });
  const [backgroundPosition, setBackgroundPosition] = useState({ x: 0, y: 0 });
  const { baseAssetUrl } = useSelector((state) => state.cart);
  const imgRef = useRef(null);
  const [tempRows, setTempRows] = useState({});
  const [buttonHover,setButtonHover]=useState(false)
  const [selectOpen,setSelectOpen]=useState(0)

/// for handling zooming lense

 const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

   const LENS_SIZE = 150;     // px
  const ZOOM = 2;  
  const containerRef = useRef(null);


  const [lensPos, setLensPos] = useState({ left: 0, top: 0 });
  const [bgPos, setBgPos] = useState({ x: 0, y: 0 });
  const [bgSize, setBgSize] = useState({ w: 0, h: 0 });
 const [starRate,setStarRate]=useState(0)
 const[textReview,setTextReview]=useState("")

  const[logoPosition,setLogoPosition]=useState(null)
  const[teamPosition,setTeamPosition]=useState(null)
  const[numberPosition,setNumberPosition]=useState(null)

  // to handle button animation
  // const bounceAnimation = `
  //   @keyframes bounceUp {
  //     0%   { transform: scale(1); }
  //     50%  { transform: scale(1.1); }
  //     100% { transform: scale(1); }
  //   }
  // `;

  const gradShift=`
  @keyframes gradientShift {
  0% {background-position:0% 50%}
  50% {background-position:100% 50%}
  100% {background-position:0% 50%}
    
  }`

  // // Inject keyframes if not already added
  // const styleSheet = document.styleSheets[0];
  // const ruleExists = Array.from(styleSheet.cssRules).some(rule =>
  //   rule.name === 'bounceUp'
  // );
  // if (!ruleExists) {
  //   styleSheet.insertRule(bounceAnimation, styleSheet.cssRules.length);
  // }

  useEffect(() => {

if(isTeam==='true'){
  setOrderType('team')
  setFromTeam(true)
}
    
  }, [isTeam])
  

  const handleMouseMove = (e) => {
    
     const container = containerRef.current;
    const img = imgRef.current;
    if (!container || !img) return;

    const rect = container.getBoundingClientRect();
    const cw = rect.width;
    const ch = rect.height;

    const naturalW = img.naturalWidth || 1;
    const naturalH = img.naturalHeight || 1;

    // How large the image is actually drawn inside the container with objectFit:"contain"
    const scale = Math.min(cw / naturalW, ch / naturalH);
    const dispW = naturalW * scale;
    const dispH = naturalH * scale;

    // The drawn image’s top-left inside the container (letterboxing)
    const imgLeft = (cw - dispW) / 2;
    const imgTop = (ch - dispH) / 2;

    // Mouse position in container space
    const xC = e.clientX - rect.left;
    const yC = e.clientY - rect.top;

    // Mouse position relative to the drawn image (clamped inside image)
    const xImg = clamp(xC - imgLeft, 0, dispW);
    const yImg = clamp(yC - imgTop, 0, dispH);

    // Lens position (center lens on cursor), clamped so lens stays fully over the image
    let left = xImg + imgLeft - LENS_SIZE / 2;
    let top = yImg + imgTop - LENS_SIZE / 2;
    left = clamp(left, imgLeft, imgLeft + dispW - LENS_SIZE);
    top = clamp(top, imgTop, imgTop + dispH - LENS_SIZE);
    setLensPos({ left, top });

    // Background sizing and offset (use pixels, not %)
    const bgW = dispW * ZOOM;
    const bgH = dispH * ZOOM;
    setBgSize({ w: bgW, h: bgH });

    // Move the big background so the point under the cursor is centered in the lens
    const bgX = -xImg * ZOOM + LENS_SIZE / 2;
    const bgY = -yImg * ZOOM + LENS_SIZE / 2;
    setBgPos({ x: bgX, y: bgY });
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "description":
        return <Description product={product} />;
      // case "designs":
      //   return <Designs />;
      case "colors":
        return <Colors />;
      // case "pickup":
      //   return <Pickup />;
      case "sizes":
        return <SizeTable />;
      case "shipping":
        return <Shipping />;
      // case "inspiration":
      //   return <Inspire />;
      default:
        return <Description product={product} />;
    }
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const[configurator ,setConfigurator]=useState({
    style:[],
    logoPosition:"",
    teamPosition:"",
    numberPosition:""
  })

  //to fetch product details
 const fetchProducts = async () => {
        try {
          console.log("productSlug:", productSlug);
          const formData = new FormData();
          formData.append("slug", productSlug);

          const response = await productDetails(productSlug);
          console.log("API response for product details:", response);

          if (response.success === true) {
            setproduct(response.data);
            setRating(response.data.rating)
            setSelectedImage(response?.data?.image);
          }
        } catch (error) {
          console.error("API Error:", error);
        } finally {
          setIsLoading(false);
        }
      };


  useEffect(() => {
    if (productSlug) {
     
      fetchProducts();
    }
  }, [productSlug]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    // Cleanup on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // useEffect(() => {
  //   const fetchStyle = async () => {
  //     try {
  //       const response = await productStyle_Api();
  //       console.log("response : ", response);

  //       if (response.success === true && Array.isArray(response.data)) {
  //         const formattedOptions = response.data.map((item) => ({
  //           value: item.title.toLowerCase().replace(/\s+/g, "-"),
  //           label: item.title,
  //         }));
  //         setOptions(formattedOptions);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching styles:", error);
  //     }
  //   };

  //   fetchStyle();
  // }, []);

  useEffect(() => {
    if (productInCart?.color_id) {
      setSelectedColor(productInCart.color_id);
    }
  }, [productInCart]);
  // Fix useEffect dependencies - watch productItems instead of state variables
  useEffect(() => {
    //console.log("productItems: ", productItems);
    const productInCart = productItems.find(
      (item) => item.product_id === product.id
    );
    //console.log("productInCart: ", productInCart);

    if (productInCart) {
      // Initialize form with existing values if they exist
      if (productInCart.styles) setSelectedOptions(productInCart.styles);
      if (productInCart.sponsor_name)
        console.log(
          "productInCart.sponsor_name : ",
          productInCart.sponsor_name
        );
      setSponsorName(productInCart.sponsor_name);
      if (productInCart.special_requests)
        setSpecialRequests(productInCart.special_requests);
      // For logo, you might want to store filename or URL instead of file object
      if (productInCart.logo_filename) {
        // Handle logo restoration if needed
        // setLogoFile(productInCart.logo_filename);
      }
    }
  }, [productItems, product.id]);

  useEffect(() => {
    if (product?.size?.length > 0 && selectedSize) {
      const price =
        product?.size?.find((s) => s.size_id === selectedSize)?.price || 0;
      //console.log("Price : ", price);
      setSelectedPrice(price);
      handleOrder(product?.size, product?.color);
    }
  }, [selectedSize, product.size]);

  useEffect(() => {
    if (cartId !== null) {
      //console.log("cartId updated:", cartId);
    }
  }, [cartId]);

  useEffect(() => {
    setLocalQuantity(0);
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      // setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleInputChange = (product_id, row_id, key, value) => {
    dispatch(updateProductRow({ product_id, row_id, key, value }));
  };

  const handleSizeChange = (product_id, row_id, value) => {
    dispatch(updateProductRow({ product_id, row_id, key: "size_id", value }));
  };

  const handleIncrementProduct = (product_id, row_id, currentQty) => {
    dispatch(
      updateProductRow({
        product_id,
        row_id,
        key: "qty",
        value: currentQty + 1,
      })
    );
  };

  const handleDecrementProduct = (product_id, row_id, currentQty) => {
    if (currentQty > 1) {
      dispatch(
        updateProductRow({
          product_id,
          row_id,
          key: "qty",
          value: currentQty - 1,
        })
      );
    }
  };

  const handleRemoveRowProduct = (product_id, row_id) => {
    dispatch(deleteProductRow({ product_id, row_id }));
  };

  const handleAddRowProduct = (product_id, product) => {
    console.log("product : ", product);
    // if (!sizeAll || sizeAll.length === 0) return;
    console.log("productItems : ", productItems);

    const existingProduct = productItems.find(
      (item) => item.product_id === product_id
    );
    const priceFromFirstRow = existingProduct?.data?.[0]?.product_price || 0;

    const matchedColorId = existingProduct?.data?.[0]?.color_id;
    console.log("matchedColorId : ", matchedColorId);

    const newRow = {
      id: Date.now(),
      name: "",
      number: "",
      size_id: product.All_Color[0].color_id,
      qty: 1,
      color_id: matchedColorId,
    };
    setTempRows((prevTempRows) => {
      const updated = {
        ...prevTempRows,
        [product_id]: [...(prevTempRows[product_id] || []), newRow],
      };

      dispatch(addProductRow({ product_id, row: newRow }));
      const { [product_id]: _, ...rest } = updated;
      return rest;
    });
  };

  const handleTempRowChangeProduct = (product_id, row_id, key, value) => {
    dispatch(updateTempProductRow({ product_id, row_id, key, value }));
  };

  const handleRemoveTempRow = (product_id, row_id) => {
    dispatch(removeTempProductRow({ product_id, row_id }));
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];

    if (file) {
      setLogoFile(file);

      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result;

        updateRedux({
          logo_base64: base64String,
          logo_filename: file.name,
        });
      };

      reader.onerror = (error) => {
        console.error("Error reading file:", error);
      };

      reader.readAsDataURL(file);
    }
  };

  const options = [
    { value: "half-sleeves", label: "Half Sleeves", type: "sleeve" },
    { value: "full-sleeves", label: "Full Sleeves", type: "sleeve" },
    { value: "polo-collar", label: "Polo Collar", type: "neck" },
    { value: "round-neck", label: "Round Neck", type: "neck" },
    { value: "v-neck", label: "V Neck", type: "neck" },
  ];

  const positionOptions=[
    { value: "front", label: "Front" },
    { value: "back", label: "Back" },
    { value: "left-sleeve", label: "Left Sleeve" },
     { value: "right-sleeve", label: "Right Sleeve" },

  ]

const handleOptionToggle = (option) => {
    setSelectedOptions((prev) => {
      // Find the option details
      const optionDetails = options.find((opt) => opt.label === option);
      if (!optionDetails) return prev;

      // Check if option is already selected
      const isSelected = prev.includes(option);

      // Create new selection array
      let newSelection = [...prev];

      if (isSelected) {
        // Remove if already selected
        newSelection = newSelection.filter((item) => item !== option);
      } else {
        // Remove any existing option of the same type
        newSelection = newSelection.filter((item) => {
          const itemDetails = options.find((opt) => opt.label === item);
          return itemDetails?.type !== optionDetails.type;
        });

        // Add new option if we have space
        if (newSelection.length < 2) {
          newSelection.push(option);
        }
      }
    //  setConfigurator(...configurator,{ styles: newSelection })
    const item={
      logoPosition:configurator.logoPosition,
      teamPosition:configurator.teamPosition,
      numberPosition:configurator.numberPosition,
      style:newSelection
    }
      setConfigurator(item)

      // Update Redux store
      updateRedux();
      return newSelection;
    });
  };


const handlePositionToggle=(type,option)=>{
    const selectedOption=positionOptions.find(p=>p.label===option)

    if(type==="logo"){
      setLogoPosition(selectedOption.label)
    }else if(type==="team"){
      setTeamPosition(selectedOption.label)
    }else if(type==="number"){
      setNumberPosition(selectedOption.label)
    }else{
      setLogoPosition(null)
      setTeamPosition(null)
      setNumberPosition(null)
    }
   // setConfigurator(...configurator,[{logoPosition:logoPosition},{teamPosition:teamPosition},{numberPosition:numberPosition}])
    const item={
      style:configurator.style,
      logoPosition:logoPosition,
      teamPosition:teamPosition,
      numberPosition:numberPosition
    }
   
   setConfigurator(item)
    updateRedux()
  }

  // Check if an option should be disabled
  const isOptionDisabled = (option) => {
    // Never disable already selected options
    if (selectedOptions.includes(option)) return false;

    // If we have 2 items selected, disable all unselected
    if (selectedOptions.length >= 2) return true;

    const optionDetails = options.find((opt) => opt.label === option);
    if (!optionDetails) return true;

    // Check if we already have an option of this type selected
    const hasTypeSelected = selectedOptions.some((item) => {
      const itemDetails = options.find((opt) => opt.label === item);
      return itemDetails?.type === optionDetails.type;
    });

    return hasTypeSelected;
  };

  const handleSponsorNameChange = (e) => {
    //console.log("e : ", e.target.value);
    const value = e.target.value;
    setSponsorName(value);
    updateRedux({ sponsor_name: value });
  };

  const handleSpecialRequestsChange = (e) => {
    //console.log("e : ", e.target.value);
    const value = e.target.value;
    setSpecialRequests(value);
    updateRedux({ special_requests: value });
  };

  const updateRedux = () => {
    //console.log("productItems : ", productItems);
    const productInCart = productItems.find(
      (item) => item.product_id === product.id
    );
    //console.log("productInCart : ", productInCart);

    setTimeout(() => {
      if (productInCart) {
      dispatch(
        addProductCustomization({
          product_id: product.id,
          ...configurator
        })
      );
      const updated = store.getState().cart.productItems;
      // Cookies.set("productItems", JSON.stringify(updated));
      localStorage.setItem("productItems", JSON.stringify(updated));
    } else {
      toast.warning(
        "Please add the product to cart first before adding customization"
      );
    }
    }, 2000);

    
  };

  const handleColorSelect = (color) => {
    const productInCart = productItems.find(
      (item) => item.product_id === product.id
    );
    //console.log("productInCart : ", productInCart);

    if (productInCart) {
      setSelectedColor(color.color_id);
      setSelectedColorName(color.name);
      dispatch(
        addProductColorCustomization({
          product_id: product.id,
          color_id: color.color_id,
          color_name: color.name,
          // color_code: color.code,
        })
      );
    } else {
      toast.warning(
        "Please add the product to cart first before adding customization"
      );
    }
  };

  if (!product.color || product.color.length === 0) return null;

  const handleSuggestionChange = (value) => {
    setSuggestion(value);
  };

  // const handleLogoUpload = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     if (!file.type.match("image.*")) {
  //       alert("Please select an image file");
  //       return;
  //     }

  //     if (file.size > 5 * 1024 * 1024) {
  //       alert("File size should be less than 5MB");
  //       return;
  //     }

  //     //console.log("Selected file:", file);
  //     const reader = new FileReader();
  //     reader.onload = (e) => {};
  //     reader.readAsDataURL(file);
  //   }
  // };

  const handleButtonClick = async () => {
    setLoading(true);
    if (!tokenDetails) {
      //toast.error("User not found. Please login.");
      return;
    }
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      const formData = new FormData();
      //console.log("subcategoryId:", product.subcategory_id);
      formData.append("subcategoryId", product.subcategory_id);

      const result = await get_glbFile(formData);
      //console.log("GLB Data:", result);

      if (result.success && result.data) {
        navigate("/3d-product", {
          state: {
            menuSlug: product.menu_slug,
            subcategorySlug: product.subcategory_slug,
            glbFile: result.data,
          },
        });
      } else {
        //toast.error("No 3D model available. Please try another product.");
      }
    } catch (error) {
      console.error("Error:", error);
      //toast.error("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleFavorite = () => {
    //console.log("product size : ", product.size);
    //console.log("selectedSize : ", selectedSizeId);
    if (!tokenDetails) {
      toast.error("Please login or Signup");
      return;
    }

    if (!selectedSizeId) {
      toast.error("Please Select Size.");
      return;
    }

    const favoriteProduct = {
      id: product.id,
      menu_id: product.menu_id,
      category_id: product.category_id,
      subcategory_id: product.subcategory_id,
      name: product.name,
      slug: product.slug,
      image: product.image,
      menu_name: product.menu_name,
      menu_slug: product.menu_slug,
      category_name: product.category_name,
      category_slug: product.category_slug,
      subcategory_name: product.subcategory_name,
      subcategory_slug: product.subcategory_slug,
      size:
        product.size.find((size) => size.size_id === selectedSizeId) || null,
    };

    if (isFavorite) {
      dispatch(removeFavorite(product.id));
    } else {
      dispatch(addFavorite(favoriteProduct));
    }
  };

  const handleSizeClick = (sizeId, name) => {
    if (!tokenDetails) {
      toast.error("Please login or Signup");
      return;
    } else {
      console.log("product.color[0].color_id : ", product);
      setSelectedColor(product.color[0].color_id);
      setSelectedColorName(product.color[0].name);
      setSelectedSizeId(sizeId);

      setSelectedSize(name);
      
    }
    //   if (product.color?.length > 0) {
    //   // setSelectedColor(product.color[0].color_id);
    //   handleColorSelect(product.color[0]);
    // }
  };

  const handleOrder = async (size, color) => {
    console.log("All size : ", size);
    if (!selectedSizeId) {
      toast.error("Size must be needed");
      return;
    }

    try {
      // Check if product already exists in Redux
      const productExists = productItems.some(
        (item) => item.product_id === product.id
      );

      if (!productExists) {
        // Product doesn't exist in Redux - call API
        const formData = new FormData();
        const cartData = {
          product: [
            {
              product_id: product.id,
              qty: quantity === 0 ? 1 : quantity,
              name: "",
              number: "",
              size_id: selectedSizeId,
              color_id: selectedColor,
            },
          ],
          glb: [{}],
        };
        console.log("cartData : ", cartData);
        formData.append("cart", JSON.stringify(cartData));

        const addToCartResponse = await addToCart(formData, tokenDetails);
        //console.log("Add to cart response:", addToCartResponse);

        if (addToCartResponse.success === true) {
          toast.success("Product added successfully");

          const newCartId = addToCartResponse.data?.cart_id;
          if (newCartId) {
            //console.log("New cart ID:", newCartId);
            setCartId(newCartId);
          }
          if(fromTeam===true){
            setIsTeamModalOpen(true)
          }

          const getCartResponse = await getCart(tokenDetails);
          //console.log("Updated cart data:", getCartResponse);

          const cartProducts = getCartResponse.data?.product || [];
          let matchedItem = null;
          let productGroup = null;

          for (const group of cartProducts) {
            matchedItem = group.data.find((item) => item.cart_id === newCartId);
            if (matchedItem) {
              productGroup = group;
              break;
            }
          }

          if (matchedItem && productGroup) {
            //console.log("Matched cart item:", matchedItem);

            const rowData = {
              id: matchedItem.id || Date.now(),
              qty: matchedItem.qty || quantity,
              name: matchedItem.name || "",
              number: matchedItem.number || "",
              size_id: matchedItem.size_id || selectedSizeId,
              color_id: selectedColor,
              color_name: selectedColorName,
              product_price: matchedItem.product_price,
              size: matchedItem.size,
            };
            console.log("rowData : ", rowData);

            dispatch(
              addProductRow({
                product_id: productGroup.product_id,
                cart_id: newCartId,
                orderType: "normal",
                product_price: productGroup.data[0]?.product_price || 0,
                product_image: productGroup.image,
                product_name: productGroup.product_name,
                All_Size: size,
                All_Color: color,
                row: rowData,
              })
            );
            setLocalQuantity(1);
          } else {
            console.warn("No matching item found with cart_id:", newCartId);
          }
        } else {
          toast.error("Please login or Signup");
        }
      } else {
        const rowData = {
          id: Date.now(),
          qty: quantity === 0 ? 1 : quantity,
          name: "",
          number: "",
          size_id: selectedSizeId,
          color_id: selectedColor,
          color_name: selectedColorName,
          product_price: product.price,
          size: { id: selectedSizeId, name: "" },
        };

        console.log("rowData : ", rowData);

        dispatch(
          addProductRow({
            product_id: product.id,
            product_price: product.price,
            product_image: product.image,
            product_name: product.name,
            row: rowData,
          })
        );
        setLocalQuantity(1);
        // toast.success("Product row added successfully");
      }
    } catch (error) {
      console.error("Error during API call:", error);
      //toast.error("An error occurred");
    }
  };

  const handleIncrement = () => {
    const newQty = localQuantity + 1;
    setLocalQuantity(newQty);

    dispatch(
      updateProductRow({
        product_id: product.id,
        key: "qty",
        value: newQty,
      })
    );
  };

  const handleDecrement = () => {
    const productInState = productItems.find(
      (item) => item.product_id === product.id
    );

    if (!productInState || !productInState.data?.length) return;

    const lastRow = productInState.data[productInState.data.length - 1];
    const currentQty = lastRow.qty;

    if (currentQty > 1) {
      const newQty = currentQty - 1;
      setLocalQuantity(newQty);

      dispatch(
        updateProductRow({
          product_id: product.id,
          row_id: lastRow.id,
          key: "qty",
          value: newQty,
        })
      );
    } else {
      dispatch(
        deleteProductRow({
          product_id: product.id,
        })
      );
      setLocalQuantity(0);
      setSelectedSize("");
      setSelectedSizeId("");
    }
  };

  const handleReviewSubmit=async()=>{

    const data=new FormData()
    data.append("product_id",JSON.stringify(product.id))
    data.append("rating",JSON.stringify(starRate))
    data.append("review",JSON.stringify(textReview))

    if(!tokenDetails){
      toast.info("Login and purchase product to review")
      return
    }

    if(product.isValidPostRating==="NO"){
      toast.info("Purchase this product to review")
      return
    }

    try {
    console.log([...data.entries()]);
      const response= await submitReview(data,tokenDetails)
      console.log(response);
      if(response.errorcode==="00"){
       toast.success("Review submitted!")
      }else{
      toast.info(response.message)
      }
      setStarRate(0)
      setTextReview("")
      fetchProducts()
      
    } catch (error) {
      console.log(error);
      
    }
  }

  if (isLoading) {
    return <SkeletonLoader />;
  }

  const handleRemove = (id) => {
    dispatch(removeCart(id));
    setCartItems((prevItems) => prevItems.filter((item) => item.id !== id));
  };

  const handleImageSelect = (imageUrl) => {
    setSelectedImage(imageUrl);
  };


   const handle3DButtonClick = async (e) => {
    e.preventDefault();
    
    
    if (!tokenDetails) {
      toast.error("Please login or Signup");
      return;
    }
    try {

      const subCategoryId=product.subcategory_id
      const formData = new FormData();
     
      formData.append("subcategoryId",subCategoryId);

      const result = await get_glbFile(formData);
      console.log("GLB Data:", result);

      if (result.success && result.data) {
        navigate("/3d-product", {
          state: {
            menuSlug: product.menu_slug,
            subcategorySlug: product.subcategory_slug,
            glbFile: result.data,
          },
        });
        console.log("details", {
            menuSlug: product.menu_slug,
            subcategorySlug: product.subcategory_slug,
            glbFile: result.data,
          })
      } else {
        toast.error("No 3D model available. Please try another product.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong. Please try again later.");
    }
  };

  const rateSlider={
     infinite: true,           // infinite loop
    slidesToShow: 1,          // show 1 item
    slidesToScroll: 1,        // scroll 1 at a time
    autoplay: true,           // enable auto sliding
    speed: 500,               // transition speed (ms)
    autoplaySpeed: 1000,      // delay between slides (ms)
    pauseOnHover: false,
    arrows:true
  }

  return (
    <div>
      <div style={{ height: "106px", overflowX: "hidden" ,backgroundColor:"white"}}></div>
      <main className="content-main" style={{backgroundColor:"#ffffff"}}>
        <div className="container">
          <div className="container-main" style={{ marginTop: "45px" }}>
            <div
              className="product-detail"
              itemScope
              itemType="https://schema.org/Product"
            >
              <div
                className="product-detail-content bgweb"
                data-product-id="c0386fdb388b4c2aadc9adb5af5be91e"
                data-product-number="781001.shield_COLORSCRATCH"
              >
                {windowWidth > 600 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "45px",
                      gap: "12px",
                    }}
                  >
                    <div
                      className="row product-detail-main block-container-2"
                      style={{
                        display: "flex",
                        width:"50%",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "start",
                          marginBottom: "45px",
                          width: "100%",
                          borderRadius:"60px",
                          marginTop:"15px",
                         
                        }}
                      >
                         <VerticalSlider
                          className="VerticalSlider-image"
                          // style={{ width: "150px" }}
                          product={product}
                          onImageSelect={handleImageSelect}
                        />
                       
                        {/* Middle slider */}
                        
                          <div 
                          ref={containerRef}
                            className="image-zoom-container"
                            style={{
                              width: "400px",
                              height: "80vh",
                              position: "relative",
                              cursor: "zoom-in",
                               overflow: "hidden",
                              borderRadius:"15px",
                               
                              
                            }}
                            onMouseEnter={() => setShowLens(true)}
                            onMouseLeave={() => setShowLens(false)}
                            onMouseMove={handleMouseMove}
                          >
                            <img
                              ref={imgRef}
                              src={selectedImage}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                display: "block",
                                userSelect: "none",
                                 pointerEvents: "none"
                              }}
                              draggable="false"
                            />

                            {showLens && (
                              <div
            className="zoom-lens"
            style={{
            position: "absolute",
            width: `${LENS_SIZE}px`,
            height: `${LENS_SIZE}px`,
            borderRadius: "50%",
            border: "2px solid #ccc",
            backgroundColor: "rgba(255,255,255,0.25)",
            pointerEvents: "none",
            left: `${lensPos.left}px`,
            top: `${lensPos.top}px`,
            zIndex: 10,
            backgroundImage: `url(${selectedImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: `${bgSize.w}px ${bgSize.h}px`,
            backgroundPosition: `${bgPos.x}px ${bgPos.y}px`,
            boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                                }}
                              />
                            )}
                          </div>

                       
                      </div>
                     
                      
                       <div className="social-proof">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "16px",
                              marginTop: "8px",
                            }}
                          >
                            <div
                              className="logo-upload-section"
                              style={{
                                padding: "16px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "12px",
                                border: "1px dashed #d1d5db",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                }}
                              >
                                <p
                                  style={{
                                    margin: "0",
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "#1f2937",
                                    fontFamily:"Poppins"
                                  }}
                                >
                                  Upload Your Logo
                                </p>

                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <label
                                    htmlFor="logo-upload"
                                    style={{
                                      padding: "8px 16px",
                                      backgroundColor: "#ffffff",
                                      border: "1px solid #d1d5db",
                                      borderRadius: "8px",
                                      cursor: "pointer",
                                      fontWeight: "500",
                                      fontSize: "14px",
                                      color: "#374151",
                                      transition: "all 0.2s ease",
                                    }}
                                  >
                                    Choose File
                                    <input
                                      id="logo-upload"
                                      type="file"
                                      accept="image/*"
                                      style={{ display: "none" }}
                                      onChange={handleLogoUpload}
                                    />
                                  </label>
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      color: "#6b7280",
                                    }}
                                  >
                                    {logoFile
                                      ? logoFile.name
                                      : "No file chosen"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* select logo */}

                            <div
                              style={{
                                padding: "16px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "12px",
                                border: "1px solid #e2e8f0",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                }}
                              >
                                <label
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "#1f2937",
                                  }}
                                >
                                  Select Logo Position
                                </label>

                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      padding: "10px 12px",
                                      borderRadius: "8px",
                                      border: "1px solid #d1d5db",
                                      fontSize: "14px",
                                      backgroundColor: "#ffffff",
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                    onClick={() => setLogoOpen(!logoOpen)}
                                  >
                                    <span>
                                    {  logoPosition?logoPosition:
                                    "Select position options"}
                                    </span>
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        transform: isOpen
                                          ? "rotate(180deg)"
                                          : "rotate(0deg)",
                                        transition: "transform 0.2s ease",
                                      }}
                                    >
                                      <path
                                        d="M6 9L12 15L18 9"
                                        stroke="#4B5563"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </div>

                                  {logoOpen && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        right: 0,
                                        marginTop: "4px",
                                        backgroundColor: "#ffffff",
                                        borderRadius: "8px",
                                        border: "1px solid #d1d5db",
                                        boxShadow:
                                          "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        zIndex: 10,
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {positionOptions.map((option) => (
                                        <label
                                          key={option.value}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "10px 12px",
                                            cursor: "pointer",
                                            transition:
                                              "background-color 0.2s ease",
                                            opacity: 1,
                                            backgroundColor: "transparent",
                                          }}
                                          onMouseEnter={(e) => {
                                            
                                              e.target.style.backgroundColor =
                                                "#f3f4f6";
                                            
                                          }}
                                          onMouseLeave={(e) => {
                                            
                                              e.target.style.backgroundColor =
                                                "transparent";
                                            
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={logoPosition===option.label}
                                            onChange={() =>
                                              handlePositionToggle("logo",option.label)
                                            }
                                           
                                            style={{
                                              marginRight: "8px",
                                              accentColor: "#3b82f6",
                                              cursor: "pointer",
                                            }}
                                          />
                                          {option.label}
                                        </label>
                                      ))}
                                    </div>
                                  )}
                                </div>
                                   {logoPosition && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "6px",
                                      marginTop: "8px",
                                    }}
                                  >
                                   
                                      <div
                                       
                                        style={{
                                          backgroundColor: "#e0e7ff",
                                          color: "#1e40af",
                                          padding: "4px 8px",
                                          borderRadius: "6px",
                                          fontSize: "12px",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {logoPosition}
                                       
                                      </div>
                               
                                  </div>
                                )}
                              
                              </div>
                            </div>

                            {/* t shirt style select */}


                            <div
                              style={{
                                padding: "16px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "12px",
                                border: "1px solid #e2e8f0",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                }}
                              >
                                <label
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "#1f2937",
                                  }}
                                >
                                  Select T-Shirt Style (Max 2: 1 Sleeve + 1
                                  Neck)
                                </label>

                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      padding: "10px 12px",
                                      borderRadius: "8px",
                                      border: "1px solid #d1d5db",
                                      fontSize: "14px",
                                      backgroundColor: "#ffffff",
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                    onClick={() => setIsOpen(!isOpen)}
                                  >
                                    <span>
                                      {selectedOptions.length > 0
                                        ? selectedOptions.join(", ")
                                        : "Select options"}
                                    </span>
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        transform: isOpen
                                          ? "rotate(180deg)"
                                          : "rotate(0deg)",
                                        transition: "transform 0.2s ease",
                                      }}
                                    >
                                      <path
                                        d="M6 9L12 15L18 9"
                                        stroke="#4B5563"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </div>

                                  {isOpen && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        right: 0,
                                        marginTop: "4px",
                                        backgroundColor: "#ffffff",
                                        borderRadius: "8px",
                                        border: "1px solid #d1d5db",
                                        boxShadow:
                                          "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        zIndex: 10,
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {options.map((option) => (
                                        <label
                                          key={option.value}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "10px 12px",
                                            cursor: isOptionDisabled(
                                              option.label
                                            )
                                              ? "not-allowed"
                                              : "pointer",
                                            transition:
                                              "background-color 0.2s ease",
                                            opacity: isOptionDisabled(
                                              option.label
                                            )
                                              ? 0.6
                                              : 1,
                                            backgroundColor: isOptionDisabled(
                                              option.label
                                            )
                                              ? "#f3f4f6"
                                              : "transparent",
                                          }}
                                          onMouseEnter={(e) => {
                                            if (
                                              !isOptionDisabled(option.label)
                                            ) {
                                              e.target.style.backgroundColor =
                                                "#f3f4f6";
                                            }
                                          }}
                                          onMouseLeave={(e) => {
                                            if (
                                              !isOptionDisabled(option.label)
                                            ) {
                                              e.target.style.backgroundColor =
                                                "transparent";
                                            }
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={selectedOptions.includes(
                                              option.label
                                            )}
                                            onChange={() =>
                                              handleOptionToggle(option.label)
                                            }
                                            disabled={isOptionDisabled(
                                              option.label
                                            )}
                                            style={{
                                              marginRight: "8px",
                                              accentColor: "#3b82f6",
                                              cursor: isOptionDisabled(
                                                option.label
                                              )
                                                ? "not-allowed"
                                                : "pointer",
                                            }}
                                          />
                                          {option.label}
                                        </label>
                                      ))}
                                    </div>
                                  )}
                                </div>

                                {selectedOptions.length > 0 && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "6px",
                                      marginTop: "8px",
                                    }}
                                  >
                                    {selectedOptions.map((option) => (
                                      <div
                                        key={option}
                                        style={{
                                          backgroundColor: "#e0e7ff",
                                          color: "#1e40af",
                                          padding: "4px 8px",
                                          borderRadius: "6px",
                                          fontSize: "12px",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {option}
                                        <button
                                          onClick={() =>
                                            handleOptionToggle(option)
                                          }
                                          style={{
                                            marginLeft: "4px",
                                            background: "none",
                                            border: "none",
                                            color: "#1e40af",
                                            cursor: "pointer",
                                            fontSize: "12px",
                                          }}
                                        >
                                          ×
                                        </button>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>


                            {!fromEventPage && (
                              <div
                                style={{
                                  padding: "16px",
                                  backgroundColor: "#f8f9fa",
                                  borderRadius: "12px",
                                  border: "1px solid #e2e8f0",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "8px",
                                  }}
                                >
                                  <label
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "600",
                                      color: "#1f2937",
                                    }}
                                  >
                                    Team Name
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Enter Team name"
                                    value={sponsorName}
                                    onChange={(e) => {
                                      console.log(
                                        "Sponsor name: ",
                                        e.target.value
                                      );
                                      setSponsorName(e.target.value);
                                      updateRedux({
                                        sponsor_name: e.target.value,
                                      });
                                    }}
                                    style={{
                                      width: "100%",
                                      padding: "10px 12px",
                                      borderRadius: "8px",
                                      border: "1px solid #d1d5db",
                                      fontSize: "14px",
                                      outline: "none",
                                      transition: "all 0.2s ease",
                                    }}
                                  />
                                </div>
                              </div>
                            )}


                            {/*  team name select */}
                             <div
                              style={{
                                padding: "16px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "12px",
                                border: "1px solid #e2e8f0",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                }}
                              >
                                <label
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "#1f2937",
                                  }}
                                >
                                  Select Team Name Position
                                </label>

                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      padding: "10px 12px",
                                      borderRadius: "8px",
                                      border: "1px solid #d1d5db",
                                      fontSize: "14px",
                                      backgroundColor: "#ffffff",
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                    onClick={() => setTeamNameOpenOpen(!teamNameOpen)}
                                  >
                                    <span>
                                     {teamPosition?teamPosition: "Select position options"}
                                    </span>
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        transform: isOpen
                                          ? "rotate(180deg)"
                                          : "rotate(0deg)",
                                        transition: "transform 0.2s ease",
                                      }}
                                    >
                                      <path
                                        d="M6 9L12 15L18 9"
                                        stroke="#4B5563"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </div>

                                  {teamNameOpen && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        right: 0,
                                        marginTop: "4px",
                                        backgroundColor: "#ffffff",
                                        borderRadius: "8px",
                                        border: "1px solid #d1d5db",
                                        boxShadow:
                                          "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        zIndex: 10,
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {positionOptions.map((option) => (
                                        <label
                                          key={option.value}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "10px 12px",
                                            cursor:  "pointer",
                                            transition:
                                              "background-color 0.2s ease",
                                            opacity: 1,
                                            backgroundColor:  "transparent",
                                          }}
                                          onMouseEnter={(e) => {
                                            
                                              e.target.style.backgroundColor =
                                                "#f3f4f6";
                                            
                                          }}
                                          onMouseLeave={(e) => {
                                           
                                              e.target.style.backgroundColor =
                                                "transparent";
                                            
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={teamPosition===option.label}
                                            onChange={() =>
                                              handlePositionToggle("team",option.label)
                                            }
                                           
                                            style={{
                                              marginRight: "8px",
                                              accentColor: "#3b82f6",
                                              cursor: "pointer",
                                            }}
                                          />
                                          {option.label}
                                        </label>
                                      ))}
                                    </div>
                                  )}
                                </div>

                                 {teamPosition && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "6px",
                                      marginTop: "8px",
                                    }}
                                  >
                                   
                                      <div
                                       
                                        style={{
                                          backgroundColor: "#e0e7ff",
                                          color: "#1e40af",
                                          padding: "4px 8px",
                                          borderRadius: "6px",
                                          fontSize: "12px",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {teamPosition}
                                       
                                      </div>
                               
                                  </div>
                                )}

                              </div>
                            </div>


                            {/* select number open */}

                             <div
                              style={{
                                padding: "16px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "12px",
                                border: "1px solid #e2e8f0",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                }}
                              >
                                <label
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "#1f2937",
                                  }}
                                >
                                  Select Number Position
                                </label>

                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      padding: "10px 12px",
                                      borderRadius: "8px",
                                      border: "1px solid #d1d5db",
                                      fontSize: "14px",
                                      backgroundColor: "#ffffff",
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                    onClick={() => setNumberOpen(!numberOpen)}
                                  >
                                    <span>
                                     {numberPosition?numberPosition:
                                     " Select position options"}
                                    </span>
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        transform: isOpen
                                          ? "rotate(180deg)"
                                          : "rotate(0deg)",
                                        transition: "transform 0.2s ease",
                                      }}
                                    >
                                      <path
                                        d="M6 9L12 15L18 9"
                                        stroke="#4B5563"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </div>

                                  {numberOpen && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        right: 0,
                                        marginTop: "4px",
                                        backgroundColor: "#ffffff",
                                        borderRadius: "8px",
                                        border: "1px solid #d1d5db",
                                        boxShadow:
                                          "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        zIndex: 10,
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {positionOptions.map((option) => (
                                        <label
                                          key={option.value}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "10px 12px",
                                            cursor:"pointer",
                                            transition:
                                              "background-color 0.2s ease",
                                            opacity:  1,
                                            backgroundColor: 
                                               "transparent",
                                          }}
                                          onMouseEnter={(e) => {
                                           
                                              e.target.style.backgroundColor =
                                                "#f3f4f6";
                                            
                                          }}
                                          onMouseLeave={(e) => {
                                           
                                              e.target.style.backgroundColor =
                                                "transparent";
                                            
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={numberPosition===option.label}
                                            onChange={() =>
                                              handlePositionToggle("number",option.label)
                                            }
                                          
                                            style={{
                                              marginRight: "8px",
                                              accentColor: "#3b82f6",
                                              cursor:"pointer",
                                            }}
                                          />
                                          {option.label}
                                        </label>
                                      ))}
                                    </div>
                                  )}
                                </div>

                                 {numberPosition && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "6px",
                                      marginTop: "8px",
                                    }}
                                  >
                                   
                                      <div
                                       
                                        style={{
                                          backgroundColor: "#e0e7ff",
                                          color: "#1e40af",
                                          padding: "4px 8px",
                                          borderRadius: "6px",
                                          fontSize: "12px",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {numberPosition}
                                       
                                      </div>
                               
                                  </div>
                                )}

                               
                              </div>
                            </div>


                            <div
                              style={{
                                padding: "16px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "12px",
                                border: "1px solid #e2e8f0",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                }}
                              >
                                <label
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "#1f2937",
                                  }}
                                >
                                  Special Requests
                                </label>
                                <textarea
                                  value={specialRequests}
                                  onChange={handleSpecialRequestsChange}
                                  placeholder="Any special instructions or requests..."
                                  style={{
                                    width: "100%",
                                    minHeight: "100px",
                                    padding: "12px",
                                    borderRadius: "8px",
                                    border: "1px solid #d1d5db",
                                    fontSize: "14px",
                                    resize: "vertical",
                                    outline: "none",
                                    transition: "all 0.2s ease",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    {/* slide slider page */}
                    <div className="DetailsSize-container"
                    style={{width:"50%",paddingTop:"50px"}}>
                      <div
                        className="col-lg-6 product-detail-buy"
                        data-detail-description="true"
                        style={{ width: "100%" }}
                      >
                        <div   style={{display:"flex", justifyContent:"space-between",alignItems:"center"}}>
                        
                        <p style={{border:"1px solid gray",borderRadius:"10px",fontSize:"15px",color:"gray",width:"fit-content",padding:"5px",display:"flex",alignItems:"center"}}>
                          <span style={{color:"black"}}>4.9 </span>| 80 <img src="/star-1.png" style={{width:"10px"}}/></p>

                           <button 
                          onClick={handle3DButtonClick}
                          style={{background:buttonHover?"linear-gradient(90deg,black, gray, black, gray)":"linear-gradient(-45deg, black, gray, black,gray)",
                            color:"white",fontSize:"14px",
                            borderRadius:"20px",border:"1px solid white",
                          padding:'12px',fontWeight:500,width:"fit-content",
                          transition:'all 0.2s ease-in-out',
                          transform:buttonHover?`scale(1.1)`:`scale(1)`,
                          backgroundSize:"400% 400%",
                          animation:`gradShift 5s ease infinite`,
                           boxShadow:buttonHover?"0 0 10px 2px gray":"0 0 10px 2px white"
                        }}
                          onMouseEnter={()=>setButtonHover(true)}
                          onMouseLeave={()=>setButtonHover(false)}
                          >
                            Customize Your Dress
                          </button>
                          </div>
                        {/* <div className="col-md-auto product-detail-manufacturer">
                          <a
                            href
                            className="product-detail-manufacturer-link"
                            rel="noreferrer noopener"
                            target="_blank"
                            title="shield"
                          >
                            {/* <img
                                src="../../../media/29/9b/3a/1639408455/element-2.svg"
                                className="product-detail-manufacturer-logo"
                                alt="shield"
                              /> *
                          </a>
                        </div> */}
                        <div className="row align-items-center justify-content-between product-detail-headline"
                        style={{display:"flex", justifyContent:"space-between",alignItems:"center"}}
                        >
                          <div className="col product-detail-name-container">
                            <p
                              className="product-detail-name t2 small1"
                              itemprop="name"
                              style={{ fontWeight: 700,fontSize:"20px",width:"70%" }}
                            >
                              {product.name}
                            </p>
                          </div>
                              
                          {/* <button 
                          onClick={handle3DButtonClick}
                          style={{background:buttonHover?"linear-gradient(90deg,black, gray, black, gray)":"linear-gradient(-45deg, black, gray, black,gray)",
                            color:"white",fontSize:"15px",
                            borderRadius:"20px",border:"1px solid white",
                          padding:'6px',fontWeight:"bold",width:"fit-content",
                          transition:'all 0.2s ease-in-out',
                          transform:buttonHover?`scale(1.1)`:`scale(1)`,
                          backgroundSize:"400% 400%",
                          animation:`gradShift 5s ease infinite`,
                           boxShadow:buttonHover?"0 0 10px 2px gray":"0 0 10px 2px white"
                        }}
                          onMouseEnter={()=>setButtonHover(true)}
                          onMouseLeave={()=>setButtonHover(false)}
                          >
                            Customize your Dress
                          </button> */}
                          
                        </div>


                        {/* <div className="description-box">
                          <div
                            className="description-box-short small1"
                            style={{ fontSize: "14px" }}
                            dangerouslySetInnerHTML={{
                              __html: product.short_description?.replace(
                                /&nbsp;/g,
                                " "
                              ),
                            }}
                          />

                          <div
                            className="description-box-long is--hidden small1"
                            style={{ fontSize: "14px" }}
                          >
                            <p>{product.description}</p>
                          </div>
                          {/* <button className="description-show-more">show more</button>
                            <button className="description-show-less is--hidden">
                              show less
                            </button> *
                        </div> */}
                        <div className="js-magnifier-zoom-image-container">
                          <div
                            itemprop="brand"
                            itemtype="https://schema.org/Brand"
                            itemscope
                          >
                            <div itemprop="name" content="shield" />
                          </div>
                          <div itemprop="releaseDate" content="2024-10-16" />
                          <div
                            itemprop="offers"
                            itemscope
                            itemtype="http://schema.org/AggregateOffer"
                          >
                            <div itemprop="url" content="781001.html" />
                            <div itemprop="lowPrice" content="29.9" />
                            <div itemprop="highPrice" content="56.9" />
                            <div itemprop="offerCount" content="9" />
                            <div itemprop="priceCurrency" content="EUR" />
                            <div
                              className="product-detail-price-container f_pricesShortContainer"
                              data-product-id="c0386fdb388b4c2aadc9adb5af5be91e"
                            >
                              <div className="prices-range-price-block">
                                <div className="product--price">
                                  <div
                                    className="price--content content--default"
                                    style={{
                                      fontWeight: "bold",
                                      marginTop: "8px",
                                    }}
                                  >
                                    <span
                                      className="price-line"
                                      style={{ fontSize: "18px" }}
                                    >
                                    
                                      <span className="f_shieldArticlePrice article-price" style={{color:"black"}}>
                                        {" "}
                                        ${product?.size[0]?.price}/-
                                      </span>
                                    </span>
                                    <span
                                      className="product-mrp"
                                      style={{
                                        fontSize: "12px",
                                        marginLeft: "14px",
                                      }}
                                    >
                                      <span className="mrp"  style={{color:"#555454ff"}}>
                                       ${product?.size[0]?.mrp}/-
                                      </span>
                                    </span>
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        color: "black",
                                        marginLeft: "10px",
                                        backgroundColor: "#ffe604ff",
                                        padding: "4px 10px",
                                        borderRadius: "6px",
                                        display: "inline-block",
                                        
                                      }}
                                    >
                                      you save ${product?.size[0]?.mrp - product?.size[0]?.price}/-
                                    </div>

                                    <style>
                                      {`
    @keyframes pulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.05); }
      100% { transform: scale(1); }
    }
  `}
                                    </style>
                                  </div>
                                </div>
                              </div>{" "}
                            </div>

                            <div className="product-detail-tax-container">
                              <p className="product-detail-tax">
                               
                              </p>

                              <div 
                              style={{display:"flex",flexDirection:"column",justifyContent:"center",gap:"5px",
                              border:"0.5px solid yellow",padding:"10px",borderRadius:"10px",marginTop:"50px",width:"fit-content"}}>
                                <p style={{fontSize:"14px",fontWeight:700,marginBottom:"0.1px"}}>2 combo jersey at 25% off</p>
                                 <p style={{fontSize:"14px",fontWeight:700,marginBottom:"0.1px"}}>2 combo jersey at 25% off</p>
                                  <p style={{fontSize:"11px",color:"green",marginBottom:"0.1px"}}>2 combo jersey at 25% off</p>
                                  <p style={{marginBottom:"0.3px"}}>__ __ __ __ __ __ __ __ __ __ __ __ __ </p>
                                  <p style={{fontSize:"14px",fontWeight:700,marginBottom:"1px"}}>Free coupon</p>
                              </div>
                            </div>
                           

                           
                            


                           
                          </div>
                        </div>


                         <div
                          className="color-selection-section"
                          style={{
                            padding: "16px",
                            marginTop:"15px",
                            backgroundColor: "#f8f9fa",
                            borderRadius: "12px",
                            border: "1px solid #e2e8f0",
                            marginBottom: "16px",
                          }}
                        >
                          <p  style={{
                              margin: "0 0 12px 0",
                              fontSize: "16px",
                              fontWeight: "600",
                              color: "#1f2937",
                            }}>Select size</p>

                          <div style={{display:"flex", flexWrap:"wrap",gap:"8px"}}>
                                {product.size.map((size, index) => (
                                <button
                                  key={size}
                                  className={`  border rounded-lg text-lg ${
                                    selectedSizeId === size.size_id
                                      ? "bg-black text-white border-black"
                                      : ""
                                  }`}
                                   style={{
                                      width: "100px",
                                      height: "30px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      border:"1px solid black"
                                    }}
                                  onClick={() =>
                                    handleSizeClick(size.size_id, size.name)
                                  }
                                >
                                  {size.name}
                                </button>
                              ))}
                          </div>

                        </div>


                        <div
                          className="color-selection-section"
                          style={{
                            padding: "16px",
                            backgroundColor: "#f8f9fa",
                            borderRadius: "12px",
                            border: "1px solid #e2e8f0",
                            marginBottom: "16px",
                          }}
                        >
                          <p
                            style={{
                              margin: "0 0 12px 0",
                              fontSize: "16px",
                              fontWeight: "600",
                              color: "#1f2937",
                            }}
                          >
                            Select Colors
                          </p>

                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              flexWrap: "wrap",
                            }}
                          >
                            {product?.color?.map((color) => (
                              <div
                                key={color.color_id}
                                onClick={() => handleColorSelect(color)}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                <div
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    borderRadius: "50%",
                                    backgroundColor: color.code,
                                    border:
                                      selectedColor === color.color_id
                                        ? "3px solid #3b82f6"
                                        : "2px solid #e5e7eb",
                                    boxShadow:
                                      selectedColor === color.color_id
                                        ? "0 4px 6px rgba(59, 130, 246, 0.3)"
                                        : "none",
                                    transition: "all 0.2s ease",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {selectedColor === color.color_id && (
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="#ffffff"
                                      strokeWidth="3"
                                    >
                                      <path d="M20 6L9 17l-5-5" />
                                    </svg>
                                  )}
                                </div>
                                {/* <span
                                  style={{
                                    fontSize: "10px",
                                    color: "#4b5563",
                                    fontWeight:
                                      selectedColor === color.color_id
                                        ? "600"
                                        : "400",
                                  }}
                                >
                                  {color.name}
                                </span> */}
                              </div>
                            ))}
                          </div>
                        </div>

                         <div
                          className="color-selection-section"
                          style={{
                            padding: "16px",
                            backgroundColor: "#f8f9fa",
                            borderRadius: "12px",
                            border: "1px solid #e2e8f0",
                            marginBottom: "16px",
                          }}
                        >
                          <p  style={{
                              margin: "0 0 12px 0",
                              fontSize: "16px",
                              fontWeight: "600",
                              color: "#1f2937",
                            }}>Order Type</p>
                             <div style={{ display: "flex", gap: "2px",flexWrap:"wrap",padding:"5px",gap:"10px",
                                   borderRadius:"10px" ,backgroundColor:"white"}}>
                           {fromTeam===false? <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                cursor: "pointer",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={orderType === "normal"}
                                onChange={() => {
                                  setOrderType("normal");
                                  dispatch(
                                    setProductOrderType({
                                      product_id: product?.id,
                                      orderType: "normal",
                                    })
                                  );
                                }}
                                style={{ accentColor: "#3b82f6" }}
                              />
                              <span style={{ fontSize: "14px" }}>Normal</span>
                            </label>:""}

                           {fromTeam===false? <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                cursor: "pointer",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={orderType === "team"}
                                onChange={() => {
                                  if (!selectedSizeId) {
                                    toast.error("Size must be needed");
                                    return;
                                  }

                                  setIsTeamModalOpen(true);
                                }}
                                style={{ accentColor: "#3b82f6" }}
                              />
                              <span style={{ fontSize: "14px" }}>
                                Team Order
                              </span>
                            </label>:
                            <div style={{padding:"10px",border:"0.5px solid gray",cursor:"pointer",fontSize:"10px",fontWeight:"bold", borderRadius:"5px"}}
                            onClick={()=>{
                              if (!selectedSizeId) {
                                    toast.error("Size must be needed");
                                    return;
                                  }
                              setIsTeamModalOpen(true)}}>
                              Team Dress Details
                              </div>}

                           {fromTeam===false? <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                cursor: "pointer",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={orderType === "family"}
                                onChange={() => {
                                  if (!selectedSizeId) {
                                    toast.error("Size must be needed");
                                    return;
                                  }
                                  setIsFamilyModalOpen(true);
                                }}
                                style={{ accentColor: "#3b82f6" }}
                              />
                              <span style={{ fontSize: "14px" }}>
                                Family Order
                              </span>
                            </label>:""}
                                  </div>
                        </div>

                        
                             <div
                            className=""
                            style={{ marginTop: "23px",width:"70%" ,marginBottom:"20px"}}
                          >
                            <div
                              id="productDetailPageBuyProductForm"
                              className="row g-2 buy-widget-container"
                              style={{
                                display: "flex",
                                gap: "6%",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              {localQuantity === 0 ? (
                                <button
                                  className="section2-one-btn"
                                  onClick={() =>
                                    handleOrder(product?.size, product?.color)
                                  }
                                  style={{
                                    padding: "8px ",
                                    borderRadius: "10px",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent:"center",
                                    gap:"10px"
                                  }}
                                >
                                  <img src="/shopping-cart.png" style={{width:"18px"}}/>
                                  <span style={{fontSize:"14px",fontWeight:500}}>Add to Cart</span>
                                </button>
                              ) : (
                                <div
                                  className="section-btn"
                                  style={{
                                    padding: "8px ",
                                    gap: "8px",
                                  }}
                                >
                                  <button
                                    className="section-add-sub"
                                    onClick={handleDecrement}
                                    style={{
                                      backgroundColor: "transparent",
                                      color: "white",
                                      borderRadius: "21px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    -
                                  </button>
                                  <span
                                    style={{
                                      backgroundColor: "transparent",
                                      color: "white",
                                    }}
                                  >
                                    {localQuantity}{" "}
                                  </span>
                                  <button
                                    className="section-add-sub"
                                    onClick={handleIncrement}
                                    style={{
                                      backgroundColor: "transparent",
                                      color: "white",
                                      borderRadius: "21px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    +
                                  </button>
                                </div>
                              )}
                              <button
                                className="section2-one-btn"
                                onClick={handleFavorite}
                                style={{
                                  padding: "6px",
                                  borderRadius: "10px",
                                  fontSize: "15px",
                                  backgroundColor:"#ffffffff",
                                  color: "black",
                                 border:"1px solid gray",
                                  display: "flex",
                                  gap: "5px",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontWeight: 800,
                                }}
                              >
                                Wishlist{" "}
                                {isFavorite ? (
                                  <FaHeart color="red" />
                                ) : (
                                  <FaRegHeart color="grey" />
                                )}
                              </button>
                            </div>
                            {localQuantity !== 0 ? (
                              <button
                                className="section2-one-btn"
                                onClick={() => navigate("/cart")}
                                style={{
                                  padding: "8px 8px",
                                  borderRadius: "21px",
                                  fontSize: "18px",
                                  fontWeight: "500",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "100%",
                                }}
                              >
                                Go to Cart
                              </button>
                            ) : (
                              ""
                            )}
                          </div>
                        


                            {/* details */}
                         <div className="product-detail-tabs">
                        <div
                          className="card card-tabs"
                          style={{ borderWidth: 0 }}
                        >
                           {/* <div
                            className="product-detail-form-container desktop-view"
                            style={{ marginTop: "23px" }}
                          >
                            <div
                              id="productDetailPageBuyProductForm"
                              className="row g-2 buy-widget-container"
                              style={{
                                display: "flex",
                                gap: "6%",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              {localQuantity === 0 ? (
                                <button
                                  className="section2-one-btn"
                                  onClick={() =>
                                    handleOrder(product?.size, product?.color)
                                  }
                                  style={{
                                    padding: "8px 17px",
                                    borderRadius: "21px",
                                    fontSize: "18px",
                                    fontWeight: "500",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  Add to Cart
                                </button>
                              ) : (
                                <div
                                  className="section-btn"
                                  style={{
                                    padding: "8px 15px",
                                    gap: "35px",
                                  }}
                                >
                                  <button
                                    className="section-add-sub"
                                    onClick={handleDecrement}
                                    style={{
                                      backgroundColor: "transparent",
                                      color: "white",
                                      borderRadius: "21px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    -
                                  </button>
                                  <span
                                    style={{
                                      backgroundColor: "transparent",
                                      color: "white",
                                    }}
                                  >
                                    {localQuantity}{" "}
                                  </span>
                                  <button
                                    className="section-add-sub"
                                    onClick={handleIncrement}
                                    style={{
                                      backgroundColor: "transparent",
                                      color: "white",
                                      borderRadius: "21px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    +
                                  </button>
                                </div>
                              )}
                              <button
                                className="section2-one-btn"
                                onClick={handleFavorite}
                                style={{
                                  padding: "5px 17px",
                                  borderRadius: "21px",
                                  fontSize: "18px",

                                  color: "white",
                                  border: "2px solid black",
                                  display: "flex",
                                  gap: "5px",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontWeight: "500",
                                }}
                              >
                                Favourite{" "}
                                {isFavorite ? (
                                  <FaHeart color="red" />
                                ) : (
                                  <FaRegHeart color="grey" />
                                )}
                              </button>
                            </div>
                            {localQuantity !== 0 ? (
                              <button
                                className="section2-one-btn"
                                onClick={() => navigate("/cart")}
                                style={{
                                  padding: "8px 17px",
                                  borderRadius: "21px",
                                  fontSize: "18px",
                                  fontWeight: "500",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "100%",
                                }}
                              >
                                Go to Cart
                              </button>
                            ) : (
                              ""
                            )}
                          </div> */}
                          <div
                            className="card-header product-detail-tab-navigation"
                            style={{ borderWidth: 0 }}
                          >
                            <ul
                              className="nav nav-tabs product-detail-tab-navigation-list"
                              role="tablist"
                              style={{ borderWidth: 0 }}
                            >
                              {[
                                { id: "description", label: "Description" },
                                // { id: "designs", label: "Designs" },
                                { id: "colors", label: "Colours" },
                                // {
                                //   id: "pickup",
                                //   label: "Prices & delivery times",
                                // },
                                { id: "sizes", label: "Size table" },
                                { id: "shipping", label: "Shipping costs" },
                                // { id: "inspiration", label: "Inspiration" },
                              ].map((tab) => (
                                <li className="nav-item" key={tab.id}>
                                  <a
                                    className={`nav-link ${
                                      activeTab === tab.id ? "active" : ""
                                    }`}
                                    onClick={() => setActiveTab(tab.id)}
                                    style={{
                                      textDecoration: "none",
                                      borderBottom:
                                        activeTab === tab.id
                                          ? "2px solid #000"
                                          : "none",
                                      paddingBottom: "8px",
                                      fontWeight: "500",
                                      paddingRight: "20px",
                                      paddingLeft: "20px",
                                    }}
                                    role="button"
                                  >
                                    {tab.label}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                          <div className="product-detail-tabs-content card-body">
                            <div
                              className="tab-content"
                              style={{ fontSize: "21px" }}
                            >
                              {renderTabContent()}
                            </div>
                          </div>
                        </div>
                      </div>

                       
                      </div>
                    </div>
                  </div>
                )}


                {/* mobile view */}
                {windowWidth < 600 && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className="row product-detail-main block-container-2"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        {/* Middle slider */}
                        <div
                          className="midddleImage-container"
                          // style={{ height: "73vh" }}
                        >
                          {/* <img src={product?.image} width="100%" height="80%" /> */}
                          <div
                            className="midddleImage-container"
                            style={{ width: "100%" }}
                          >
                            <MoblieVertical
                              product={product}
                              onImageSelect={handleImageSelect}
                            />
                          </div>
                          <div
                            className="product-detail-form-container desktop-view"
                            style={{ marginTop: "23px" }}
                          >
                            <div
                              id="productDetailPageBuyProductForm"
                              className="row g-2 buy-widget-container"
                              style={{
                                display: "flex",
                                gap: "8px",
                                alignItems: "center",
                                flexDirection:"row",
                                justifyContent: "space-between",
                              }}
                            >
                              {localQuantity === 0 ? (
                                <button
                                  className="section2-one-btn"
                                  onClick={() =>
                                    handleOrder(product?.size, product?.color)
                                  }
                                  style={{
                                    padding: "8px 12px",
                                    borderRadius: "21px",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width:"48%"
                                  }}
                                >
                                  <img src="/shopping-cart.png" style={{width:"22px",paddingRight:"8px"}}/>
                                  Add to Cart
                                </button>
                              ) : (
                                <div
                                  className="section-btn"
                                  style={{
                                    padding: "10px 12px ",
                                    gap: "30px",
                                    height:""
                                  }}
                                >
                                  <button
                                    className="section-add-sub"
                                    onClick={handleDecrement}
                                    style={{
                                      backgroundColor: "transparent",
                                      color: "white",
                                      borderRadius: "20px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontSize:"10px"
                                    }}
                                  >
                                    -
                                  </button>
                                  <span
                                    style={{
                                      backgroundColor: "transparent",
                                      color: "white",
                                      fontSize:"10px"
                                    }}
                                  >
                                    {localQuantity}{" "}
                                  </span>
                                  <button
                                    className="section-add-sub"
                                    onClick={handleIncrement}
                                    style={{
                                      backgroundColor: "transparent",
                                      color: "white",
                                      borderRadius: "20px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontSize:"10px"
                                    }}
                                  >
                                    +
                                  </button>
                                </div>
                              )}
                              <button
                                className="section2-one-btn"
                                onClick={handleFavorite}
                                style={{
                                  padding: "8px 12px",
                                  borderRadius: "21px",
                                  fontSize: "12px",
                                  color:"black",
                                  backgroundColor:"#ffffffff",
                                  width:"48%",
                                 border:"0.5px solid gray",
                                  display: "flex",
                                  gap: "5px",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontWeight: 700,
                                }}
                              >
                                Wishlist{" "}
                               <div style={{fontSize:"18px"}}>
                                {isFavorite ? (
                                  <FaHeart color="red" />
                                ) : (
                                  <FaRegHeart color="grey" />
                                )}</div> 

                              </button>
                            </div>
                            {localQuantity !== 0 ? (
                              <button
                                className="section2-one-btn"
                                onClick={() => navigate("/cart")}
                                style={{
                                  padding: "8px 17px",
                                  borderRadius: "21px",
                                  fontSize: "18px",
                                  fontWeight: "500",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "100%",
                                }}
                              >
                                Go to Cart
                              </button>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      {/*slide slider */}
                      <div className="DetailsSize-container">
                        <div
                          className="col-lg-6 product-detail-buy"
                          data-detail-description="true"
                          style={{ width: "100%" }}
                        >
                          <div className="col-md-auto product-detail-manufacturer">
                            <a
                              href
                              className="product-detail-manufacturer-link"
                              rel="noreferrer noopener"
                              target="_blank"
                              title="shield"
                            >
                              {/* <img
                                src="../../../media/29/9b/3a/1639408455/element-2.svg"
                                className="product-detail-manufacturer-logo"
                                alt="shield"
                              /> */}
                            </a>
                          </div>
                          <div className=" product-detail-headline">
                            <div className="col product-detail-name-container">
                              <p
                                className="product-detail-name t2 small1"
                                itemprop="name"
                                style={{ fontWeight:500,fontSize:"20px" }}
                              >
                                {product.name}
                              </p>
                            </div>
                                 <button
                                 onClick={handle3DButtonClick}
                          style={{background:buttonHover?"linear-gradient(90deg, gray, white, gray, black)":"linear-gradient(-45deg, gray, white, gray, black)",
                            color:"white",fontSize:"10px",
                            borderRadius:"15px",border:"1px solid white",
                          padding:'10px',fontWeight:"bold",width:"fit-content",
                          transition:'all 0.2s ease-in-out',
                          transform:buttonHover?`scale(1.1)`:`scale(1)`,
                          backgroundSize:"400% 400%",
                          animation:`gradShift 5s ease infinite`,
                          boxShadow:buttonHover?"0 0 10px 2px gray":"0 0 10px 2px white"
                        }}
                          onMouseEnter={()=>setButtonHover(true)}
                          onMouseLeave={()=>setButtonHover(false)}
                          >
                              Customize your dress
                            </button>
                          </div>

                          <div className="description-box" style={{marginTop:"10px"}}>
                            <div
                              className="description-box-short small1"
                              style={{ fontSize: "14px" }}
                              dangerouslySetInnerHTML={{
                                __html: product.short_description?.replace(
                                  /&nbsp;/g,
                                  " "
                                ),
                              }}
                            />

                            <div
                              className="description-box-long is--hidden small1"
                              style={{ fontSize: "14px", }}
                            >
                              <p>{product.description}</p>
                            </div>
                            {/* <button className="description-show-more">show more</button>
                            <button className="description-show-less is--hidden">
                              show less
                            </button> */}
                          </div>
                          <div className="js-magnifier-zoom-image-container">
                            <div
                              itemprop="brand"
                              itemtype="https://schema.org/Brand"
                              itemscope
                            >
                              <div itemprop="name" content="shield" />
                            </div>
                            <div itemprop="releaseDate" content="2024-10-16" />
                            <div
                              itemprop="offers"
                              itemscope
                              itemtype="http://schema.org/AggregateOffer"
                            >
                              <div itemprop="url" content="781001.html" />
                              <div itemprop="lowPrice" content="29.9" />
                              <div itemprop="highPrice" content="56.9" />
                              <div itemprop="offerCount" content="9" />
                              <div itemprop="priceCurrency" content="EUR" />
                              <div
                                className="product-detail-price-container f_pricesShortContainer"
                                data-product-id="c0386fdb388b4c2aadc9adb5af5be91e"
                              >
                                <div className="prices-range-price-block">
                                  <div className="product--price">
                                    <div className="price--content content--default">
                                      <span
                                        className="price-line"
                                        style={{ fontSize: "14px" }}
                                      >
                                      
                                        <span className="f_shieldArticlePrice article-price" 
                                        style={{margin:"3px",color:"black",fontSize:"18px"}}>
                                          {/* $ {selectedPrice} */}${" "}
                                          {product?.size[0]?.price}/-
                                        </span>
                                      </span>
                                      <span
                                        className="product-mrp"
                                        style={{ fontSize: "12px" }}
                                      >
                                        <span className="mrp" style={{color:"#707070ff",marginLeft:"4px",fontSize:"14px"}}>
                                          ${product?.size[0]?.mrp}/-
                                        </span>
                                      </span>
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          marginLeft: "10px",
                                          color: "black",
                                          backgroundColor: "#ffe602ff",
                                          padding: "4px 10px",
                                          borderRadius: "6px",
                                          display: "inline-block",
                                          animation:
                                            "pulse 1.5s infinite ease-in-out",
                                        }}
                                      >
                                       you save ${product?.size[0]?.mrp-product?.size[0]?.price}/-
                                        
                                      </div>

                                      <style>
                                        {`
    @keyframes pulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.05); }
      100% { transform: scale(1); }
    }
  `}
                                      </style>
                                    </div>
                                  </div>
                                </div>{" "}
                              </div>

                               <div 
                              style={{display:"flex",flexDirection:"column",justifyContent:"center",gap:"5px",
                              border:"0.5px solid yellow",padding:"10px",borderRadius:"10px",marginTop:"50px",width:"fit-content"}}>
                                <p style={{fontSize:"14px",fontWeight:700,marginBottom:"0.1px"}}>2 combo jersey at 25% off</p>
                                 <p style={{fontSize:"14px",fontWeight:700,marginBottom:"0.1px"}}>2 combo jersey at 25% off</p>
                                  <p style={{fontSize:"8px",color:"green",marginBottom:"0.1px"}}>2 combo jersey at 25% off</p>
                                  <p style={{marginBottom:"0.3px"}}>__ __ __ __ __ __ __ __ __ __ __ __ __ </p>
                                  <p style={{fontSize:"14px",fontWeight:700,marginBottom:"1px"}}>Free coupon</p>
                              </div>

                              <div className="product-detail-tax-container">
                                <p className="product-detail-tax">
                                  {/* <a className="product-detail-tax-link go-shipping-tab">
                                    Prices incl. VAT plus shipping costs
                                  </a> */}
                                </p>
                              </div>
                              <div className="product-detail-delivery-information">
                                <div className="product-delivery-information"></div>
                              </div>
                              <div
                                className="flex items-center space-x-4"
                                style={{
                                  justifyContent: "space-between",
                                  display: "flex",
                                }}
                              >
                                <span
                                  className="text-lg font-semibold small1"
                                  style={{
                                    fontWeight: "800",
                                    fontSize: "14px",
                                  }}
                                >
                                  Select Size
                                </span>
                                <button className="flex items-center space-x-1 text-black font-semibold small1">
                                  {/* <FaRulerCombined className="text-lg" /> */}
                                  <span
                                    onClick={() => navigate("/size-table")}
                                    style={{
                                      fontWeight: "800",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Size Guide
                                  </span>
                                </button>
                              </div>
                              <div
                                className="flex space-x-2"
                                style={{
                                  marginBottom: "20px",
                                  marginTop: "15px",
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "6px",
                                }}
                              >
                                {product.size.map((size, index) => (
                                  <button
                                    key={size}
                                    className={`  border rounded-lg text-lg ${
                                      selectedSizeId === size.size_id
                                        ? "bg-black text-white border-black"
                                        : " "
                                    }`}
                                    style={{
                                      width: "90px",
                                      height: "36px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                    onClick={() =>
                                      handleSizeClick(size.size_id, size.name)
                                    }
                                  >
                                    {size.name}
                                  </button>
                                ))}
                              </div>
                            </div>
                          </div>
                          <div
                            className="color-selection-section"
                            style={{
                              padding: "16px",
                              backgroundColor: "#f8f9fa",
                              borderRadius: "12px",
                              border: "1px solid #e2e8f0",
                              marginBottom: "16px",
                            }}
                          >
                            <p
                              style={{
                                margin: "0 0 12px 0",
                                fontSize: "14px",
                                fontWeight: "800",
                                color: "#1f2937",
                                fontFamily:"Poppins"
                              }}
                            >
                              Select Colors
                            </p>

                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                flexWrap: "wrap",
                              }}
                            >
                              {product.color.map((color) => (
                                <div
                                  key={color.color_id}
                                  onClick={() => handleColorSelect(color)}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: "4px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "50%",
                                      backgroundColor: color.code,
                                      border:
                                        selectedColor === color.color_id
                                          ? "3px solid #3b82f6"
                                          : "2px solid #e5e7eb",
                                      boxShadow:
                                        selectedColor === color.color_id
                                          ? "0 4px 6px rgba(59, 130, 246, 0.3)"
                                          : "none",
                                      transition: "all 0.2s ease",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {selectedColor === color.color_id && (
                                      <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#ffffff"
                                        strokeWidth="3"
                                      >
                                        <path d="M20 6L9 17l-5-5" />
                                      </svg>
                                    )}
                                  </div>
                                  {/* <span
                                    style={{
                                      fontSize: "10px",
                                      color: "#4b5563",
                                      fontWeight:
                                        selectedColor === color.color_id
                                          ? "600"
                                          : "400",
                                    }}
                                  >
                                    {color.name}
                                  </span> */}
                                </div>
                              ))}
                            </div>
                          </div>
                          <div
                            style={{
                              padding: "16px",
                              backgroundColor: "#f8f9fa",
                              borderRadius: "12px",
                              border: "1px solid #e2e8f0",
                              marginBottom: "16px",
                            }}
                          >
                            <p
                              style={{
                                margin: "0 0 12px 0",
                                fontSize: "14px",
                                fontWeight: "800",
                                color: "#1f2937",
                               
                                width:"fit-content",
                                 fontFamily:"Poppins"
                              }}
                            >
                              Order Type
                            </p>

                            <div style={{ display: "flex", gap: "16px" }}>
                              {fromTeam===false?<label
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  cursor: "pointer",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={orderType === "normal"}
                                  onChange={() => {
                                    setOrderType("normal");
                                    dispatch(
                                      setProductOrderType({
                                        product_id: product?.id,
                                        orderType: "normal",
                                      })
                                    );
                                  }}
                                  style={{ accentColor: "#3b82f6" }}
                                />
                                <span style={{ fontSize: "12px" }}>Normal</span>
                              </label>:""}

                              {fromTeam===false?<label
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  cursor: "pointer",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={orderType === "team"}
                                  onChange={() => {
                                    if (!selectedSizeId) {
                                      toast.error("Size must be needed");
                                      return;
                                    }

                                    setIsTeamModalOpen(true);
                                  }}
                                  style={{ accentColor: "#3b82f6" }}
                                />
                                <span style={{ fontSize: "12px" }}>
                                  Team Order
                                </span>
                              </label>:
                              
                              <div style={{padding:"5px",border:"0.5px solid gray",cursor:"pointer",fontSize:"6px",fontWeight:"bold", borderRadius:"5px"}}
                            onClick={()=>{
                              if (!selectedSizeId) {
                                    toast.error("Size must be needed");
                                    return;
                                  }
                              setIsTeamModalOpen(true)}}>
                              Team Order
                              </div>}

                             {fromTeam===false? <label
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  cursor: "pointer",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={orderType === "family"}
                                  onChange={() => {
                                    if (!selectedSizeId) {
                                      toast.error("Size must be needed");
                                      return;
                                    }
                                    setIsFamilyModalOpen(true);
                                  }}
                                  style={{ accentColor: "#3b82f6" }}
                                />
                                <span style={{ fontSize: "12px" }}>
                                  Family Order
                                </span>
                              </label>:""}
                            </div>
                          </div>
                          <div className="social-proof">
                            {/* <div
                              className="social-proof-text small1"
                              style={{ fontSize: "14px" }}
                            >
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: product.short_description?.replace(
                                    /&nbsp;/g,
                                    " "
                                  ),
                                }}
                              />
                            </div> */}

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "16px",
                                marginTop: "8px",
                              }}
                            >
                              <div
                                className="logo-upload-section"
                                style={{
                                  padding: "16px",
                                  backgroundColor: "#f8f9fa",
                                  borderRadius: "12px",
                                  border: "1px dashed #d1d5db",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "8px",
                                  }}
                                >
                                  <p
                                    style={{
                                      margin: "0",
                                      fontSize: "14px",
                                      fontWeight: "600",
                                      color: "#1f2937",
                                       fontFamily:"Poppins"
                                    }}
                                  >
                                    Upload Your Logo
                                  </p>

                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <label
                                      htmlFor="logo-upload"
                                      style={{
                                        padding: "8px 16px",
                                        backgroundColor: "#ffffff",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                        fontWeight: "500",
                                        fontSize: "14px",
                                        color: "#374151",
                                        transition: "all 0.2s ease",
                                      }}
                                    >
                                      Choose File
                                      <input
                                        id="logo-upload"
                                        type="file"
                                        accept="image/*"
                                        style={{ display: "none" }}
                                        onChange={handleLogoUpload}
                                      />
                                    </label>
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        color: "#6b7280",
                                      }}
                                    >
                                      {logoFile
                                        ? logoFile.name
                                        : "No file chosen"}
                                    </span>
                                  </div>
                                </div>
                              </div>

                               {/* select logo */}

                            <div
                              style={{
                                padding: "16px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "12px",
                                border: "1px solid #e2e8f0",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                }}
                              >
                                <label
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "#1f2937",
                                  }}
                                >
                                  Select Logo Position
                                </label>

                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      padding: "10px 12px",
                                      borderRadius: "8px",
                                      border: "1px solid #d1d5db",
                                      fontSize: "14px",
                                      backgroundColor: "#ffffff",
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                    onClick={() => setLogoOpen(!logoOpen)}
                                  >
                                    <span>
                                      {logoPosition?logoPosition:"Select position options"}
                                    </span>
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        transform: isOpen
                                          ? "rotate(180deg)"
                                          : "rotate(0deg)",
                                        transition: "transform 0.2s ease",
                                      }}
                                    >
                                      <path
                                        d="M6 9L12 15L18 9"
                                        stroke="#4B5563"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </div>

                                  {logoOpen && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        right: 0,
                                        marginTop: "4px",
                                        backgroundColor: "#ffffff",
                                        borderRadius: "8px",
                                        border: "1px solid #d1d5db",
                                        boxShadow:
                                          "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        zIndex: 10,
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {positionOptions.map((option) => (
                                        <label
                                          key={option.value}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "10px 12px",
                                            cursor: "pointer",
                                            transition:
                                              "background-color 0.2s ease",
                                            opacity: 1,
                                            backgroundColor: "transparent",
                                          }}
                                          onMouseEnter={(e) => {
                                            
                                              e.target.style.backgroundColor =
                                                "#f3f4f6";
                                            
                                          }}
                                          onMouseLeave={(e) => {
                                            
                                              e.target.style.backgroundColor =
                                                "transparent";
                                            
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={logoPosition===option.label}
                                            onChange={() =>
                                              handlePositionToggle("logo",option.label)
                                            }
                                           
                                            style={{
                                              marginRight: "8px",
                                              accentColor: "#3b82f6",
                                              cursor: "pointer",
                                            }}
                                          />
                                          {option.label}
                                        </label>
                                      ))}
                                    </div>
                                  )}
                                </div>

                                {logoPosition && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "6px",
                                      marginTop: "8px",
                                    }}
                                  >
                                   
                                      <div
                                        
                                        style={{
                                          backgroundColor: "#e0e7ff",
                                          color: "#1e40af",
                                          padding: "4px 8px",
                                          borderRadius: "6px",
                                          fontSize: "12px",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {logoPosition}
                                        
                                      </div>
                                   
                                  </div>
                                )}
                              </div>
                            </div>

                              <div
                                style={{
                                  padding: "16px",
                                  backgroundColor: "#f8f9fa",
                                  borderRadius: "12px",
                                  border: "1px solid #e2e8f0",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "8px",
                                  }}
                                >
                                  <label
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "600",
                                      color: "#1f2937",
                                    }}
                                  >
                                    Select T-Shirt Style (Max 2: 1 Sleeve + 1
                                    Neck)
                                  </label>

                                  <div
                                    style={{
                                      position: "relative",
                                      width: "100%",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "100%",
                                        padding: "10px 12px",
                                        borderRadius: "8px",
                                        border: "1px solid #d1d5db",
                                        fontSize: "14px",
                                        backgroundColor: "#ffffff",
                                        cursor: "pointer",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                      onClick={() => setIsOpen(!isOpen)}
                                    >
                                      <span>
                                        {selectedOptions.length > 0
                                          ? selectedOptions.join(", ")
                                          : "Select options"}
                                      </span>
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        style={{
                                          transform: isOpen
                                            ? "rotate(180deg)"
                                            : "rotate(0deg)",
                                          transition: "transform 0.2s ease",
                                        }}
                                      >
                                        <path
                                          d="M6 9L12 15L18 9"
                                          stroke="#4B5563"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </div>

                                    {isOpen && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "100%",
                                          left: 0,
                                          right: 0,
                                          marginTop: "4px",
                                          backgroundColor: "#ffffff",
                                          borderRadius: "8px",
                                          border: "1px solid #d1d5db",
                                          boxShadow:
                                            "0 4px 6px rgba(0, 0, 0, 0.1)",
                                          zIndex: 10,
                                          maxHeight: "200px",
                                          overflowY: "auto",
                                        }}
                                      >
                                        {options.map((option) => (
                                          <label
                                            key={option.value}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              padding: "10px 12px",
                                              cursor: isOptionDisabled(
                                                option.label
                                              )
                                                ? "not-allowed"
                                                : "pointer",
                                              transition:
                                                "background-color 0.2s ease",
                                              opacity: isOptionDisabled(
                                                option.label
                                              )
                                                ? 0.6
                                                : 1,
                                              backgroundColor: isOptionDisabled(
                                                option.label
                                              )
                                                ? "#f3f4f6"
                                                : "transparent",
                                            }}
                                            onMouseEnter={(e) => {
                                              if (
                                                !isOptionDisabled(option.label)
                                              ) {
                                                e.target.style.backgroundColor =
                                                  "#f3f4f6";
                                              }
                                            }}
                                            onMouseLeave={(e) => {
                                              if (
                                                !isOptionDisabled(option.label)
                                              ) {
                                                e.target.style.backgroundColor =
                                                  "transparent";
                                              }
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              checked={selectedOptions.includes(
                                                option.label
                                              )}
                                              onChange={() =>
                                                handleOptionToggle(option.label)
                                              }
                                              disabled={isOptionDisabled(
                                                option.label
                                              )}
                                              style={{
                                                marginRight: "8px",
                                                accentColor: "#3b82f6",
                                                cursor: isOptionDisabled(
                                                  option.label
                                                )
                                                  ? "not-allowed"
                                                  : "pointer",
                                              }}
                                            />
                                            {option.label}
                                          </label>
                                        ))}
                                      </div>
                                    )}
                                  </div>

                                  {selectedOptions.length > 0 && (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "6px",
                                        marginTop: "8px",
                                      }}
                                    >
                                      {selectedOptions.map((option) => (
                                        <div
                                          key={option}
                                          style={{
                                            backgroundColor: "#e0e7ff",
                                            color: "#1e40af",
                                            padding: "4px 8px",
                                            borderRadius: "6px",
                                            fontSize: "12px",
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          {option}
                                          <button
                                            onClick={() =>
                                              handleOptionToggle(option)
                                            }
                                            style={{
                                              marginLeft: "4px",
                                              background: "none",
                                              border: "none",
                                              color: "#1e40af",
                                              cursor: "pointer",
                                              fontSize: "12px",
                                            }}
                                          >
                                            ×
                                          </button>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div
                                style={{
                                  padding: "16px",
                                  backgroundColor: "#f8f9fa",
                                  borderRadius: "12px",
                                  border: "1px solid #e2e8f0",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "8px",
                                  }}
                                >
                                  <label
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "600",
                                      color: "#1f2937",
                                    }}
                                  >
                                    Team Name
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Enter Team name"
                                    value={sponsorName}
                                    onChange={(e) => {
                                      console.log(
                                        "Sponsor name: ",
                                        e.target.value
                                      );
                                      setSponsorName(e.target.value);
                                      updateRedux({
                                        sponsor_name: e.target.value,
                                      });
                                    }}
                                    style={{
                                      width: "100%",
                                      padding: "10px 12px",
                                      borderRadius: "8px",
                                      border: "1px solid #d1d5db",
                                      fontSize: "14px",
                                      outline: "none",
                                      transition: "all 0.2s ease",
                                    }}
                                  />
                                </div>
                              </div>

                               {/*  team name select */}
                             <div
                              style={{
                                padding: "16px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "12px",
                                border: "1px solid #e2e8f0",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                }}
                              >
                                <label
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "#1f2937",
                                  }}
                                >
                                  Select Team Name Position
                                </label>

                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      padding: "10px 12px",
                                      borderRadius: "8px",
                                      border: "1px solid #d1d5db",
                                      fontSize: "14px",
                                      backgroundColor: "#ffffff",
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                    onClick={() => setTeamNameOpenOpen(!teamNameOpen)}
                                  >
                                    <span>
                                     {teamPosition?teamPosition:" Select position options"}
                                    </span>
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        transform: isOpen
                                          ? "rotate(180deg)"
                                          : "rotate(0deg)",
                                        transition: "transform 0.2s ease",
                                      }}
                                    >
                                      <path
                                        d="M6 9L12 15L18 9"
                                        stroke="#4B5563"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </div>

                                  {teamNameOpen && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        right: 0,
                                        marginTop: "4px",
                                        backgroundColor: "#ffffff",
                                        borderRadius: "8px",
                                        border: "1px solid #d1d5db",
                                        boxShadow:
                                          "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        zIndex: 10,
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {positionOptions.map((option) => (
                                        <label
                                          key={option.value}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "10px 12px",
                                            cursor:  "pointer",
                                            transition:
                                              "background-color 0.2s ease",
                                            opacity: 1,
                                            backgroundColor:  "transparent",
                                          }}
                                          onMouseEnter={(e) => {
                                            
                                              e.target.style.backgroundColor =
                                                "#f3f4f6";
                                            
                                          }}
                                          onMouseLeave={(e) => {
                                           
                                              e.target.style.backgroundColor =
                                                "transparent";
                                            
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={teamPosition===option.label}
                                            onChange={() =>
                                              handlePositionToggle("team",option.label)
                                            }
                                           
                                            style={{
                                              marginRight: "8px",
                                              accentColor: "#3b82f6",
                                              cursor: "pointer",
                                            }}
                                          />
                                          {option.label}
                                        </label>
                                      ))}
                                    </div>
                                  )}
                                </div>

                                {teamPosition && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "6px",
                                      marginTop: "8px",
                                    }}
                                  >
                                 
                                      <div
                                        
                                        style={{
                                          backgroundColor: "#e0e7ff",
                                          color: "#1e40af",
                                          padding: "4px 8px",
                                          borderRadius: "6px",
                                          fontSize: "12px",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {teamPosition}
                                        
                                      </div>
                                   
                                  </div>
                                )}
                              </div>
                            </div>


                            {/* select number open */}

                             <div
                              style={{
                                padding: "16px",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "12px",
                                border: "1px solid #e2e8f0",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "8px",
                                }}
                              >
                                <label
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "#1f2937",
                                  }}
                                >
                                  Select Number Position
                                </label>

                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      padding: "10px 12px",
                                      borderRadius: "8px",
                                      border: "1px solid #d1d5db",
                                      fontSize: "14px",
                                      backgroundColor: "#ffffff",
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                    onClick={() => setNumberOpen(!numberOpen)}
                                  >
                                    <span>
                                      {numberPosition?numberPosition:"Select position options"}
                                    </span>
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        transform: isOpen
                                          ? "rotate(180deg)"
                                          : "rotate(0deg)",
                                        transition: "transform 0.2s ease",
                                      }}
                                    >
                                      <path
                                        d="M6 9L12 15L18 9"
                                        stroke="#4B5563"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </div>

                                  {numberOpen && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        right: 0,
                                        marginTop: "4px",
                                        backgroundColor: "#ffffff",
                                        borderRadius: "8px",
                                        border: "1px solid #d1d5db",
                                        boxShadow:
                                          "0 4px 6px rgba(0, 0, 0, 0.1)",
                                        zIndex: 10,
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {positionOptions.map((option) => (
                                        <label
                                          key={option.value}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "10px 12px",
                                            cursor:"pointer",
                                            transition:
                                              "background-color 0.2s ease",
                                            opacity:  1,
                                            backgroundColor: 
                                               "transparent",
                                          }}
                                          onMouseEnter={(e) => {
                                           
                                              e.target.style.backgroundColor =
                                                "#f3f4f6";
                                            
                                          }}
                                          onMouseLeave={(e) => {
                                           
                                              e.target.style.backgroundColor =
                                                "transparent";
                                            
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={numberPosition===option.label}
                                            onChange={() =>
                                              handlePositionToggle("number",option.label)
                                            }
                                          
                                            style={{
                                              marginRight: "8px",
                                              accentColor: "#3b82f6",
                                              cursor:"pointer",
                                            }}
                                          />
                                          {option.label}
                                        </label>
                                      ))}
                                    </div>
                                  )}
                                </div>

                                {numberPosition && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "6px",
                                      marginTop: "8px",
                                    }}
                                  >
                                   
                                      <div
                                       
                                        style={{
                                          backgroundColor: "#e0e7ff",
                                          color: "#1e40af",
                                          padding: "4px 8px",
                                          borderRadius: "6px",
                                          fontSize: "12px",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {numberPosition}
                                       
                                      </div>
                               
                                  </div>
                                )}
                              </div>
                            </div>

                              <div
                                style={{
                                  padding: "16px",
                                  backgroundColor: "#f8f9fa",
                                  borderRadius: "12px",
                                  border: "1px solid #e2e8f0",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "8px",
                                  }}
                                >
                                  <label
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "600",
                                      color: "#1f2937",
                                    }}
                                  >
                                    Special Requests
                                  </label>
                                  <textarea
                                    value={specialRequests}
                                    onChange={handleSpecialRequestsChange}
                                    placeholder="Any special instructions or requests..."
                                    style={{
                                      width: "100%",
                                      minHeight: "100px",
                                      padding: "12px",
                                      borderRadius: "8px",
                                      border: "1px solid #d1d5db",
                                      fontSize: "14px",
                                      resize: "vertical",
                                      outline: "none",
                                      transition: "all 0.2s ease",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* description page */}

                    <div className="product-detail-tabs">
                      <div
                        className="card card-tabs"
                        style={{ borderWidth: 0 }}
                      >
                        <div
                          className="card-header product-detail-tab-navigation"
                          style={{ borderWidth: 0 }}
                        >
                          <ul
                            className="nav nav-tabs product-detail-tab-navigation-list"
                            role="tablist"
                            style={{ borderWidth: 0 }}
                          >
                            {[
                              { id: "description", label: "Description" },
                              // { id: "designs", label: "Designs" },
                              { id: "colors", label: "Colours" },
                              // {
                              //   id: "pickup",
                              //   label: "Prices & delivery times",
                              // },
                              { id: "sizes", label: "Size table" },
                              { id: "shipping", label: "Shipping costs" },
                              // { id: "inspiration", label: "Inspiration" },
                            ].map((tab) => (
                              <li className="nav-item" key={tab.id}>
                                <a
                                  className={`nav-link ${
                                    activeTab === tab.id ? "active" : ""
                                  }`}
                                  onClick={() => setActiveTab(tab.id)}
                                  style={{
                                    textDecoration: "none",
                                    borderBottom:
                                      activeTab === tab.id
                                        ? "2px solid #000"
                                        : "none",
                                    paddingBottom: "8px",
                                    fontWeight: "500",
                                    paddingRight: "20px",
                                    paddingLeft: "20px",
                                  }}
                                  role="button"
                                >
                                  {tab.label}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="product-detail-tabs-content card-body">
                          <div
                            className="tab-content"
                            style={{ fontSize: "21px" }}
                          >
                            {renderTabContent()}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}


                {/* rating section */}

              
              <div 
                style={{display:"flex",alignItems:"center",flexDirection:mobile?"column":"row",justifyContent:"space-between",width:"100%",fontFamily:"Poppins"}}>
                
                 {rateMode? 
                  <div style={{borderRadius:"12px", boxShadow: "4px 4px 12px rgba(0,0,0,0.3)",width:mobile?"95%":"45%",height:"280px",padding:"15px"}}>
                  <p style={{fontWeight:"500",fontSize:"22px"}}>Rate this product</p>
                  <div style={{display:"flex",alignItems:"center",gap:"3px"}}>
                    {
                      [1,2,3,4,5].map(i=>
                      <div style={{padding:"8px"}}
                      onClick={()=>{
                        setStarRate(i)
                      }}
                      >
                        <img src={starRate>=i?`/asset/img/star-fill.png`:"/asset/img/star-empty.png"} style={{width:"20px"}}/>
                      </div>)
                    }
                  </div>
                  <textarea
                  value={textReview}
                  onChange={(e)=>setTextReview(e.target.value)}
                  placeholder="Write your review aboute this product"
                  style={{width:"90%",padding:"8px",borderRadius:"8px",height:"110px",border:"0.5px solid gray",fontSize:"15px"}}
                  >

                  </textarea>
                  <p onClick={handleReviewSubmit}
                  style={{boxShadow: "4px 4px 12px rgba(0,0,0,0.3)",cursor:"pointer",padding:"6px",borderRadius:"10px",color:"white",fontWeight:"600",width:"fit-content",backgroundColor:"#295bfdff"}}>
                    Submit</p>

                  </div>
  :
                  <div>
                  <p onClick={()=>setRateMode(true)}
                  style={{boxShadow: "4px 4px 12px rgba(0,0,0,0.3)",cursor:"pointer",padding:"10px",borderRadius:"10px",color:"white",fontWeight:"600",width:"fit-content",backgroundColor:"#295bfdff"}}>
                    Rate this product </p>
                
                </div>}
                  
              {  rating.length>0 ?
                 <div style={{borderRadius:"12px", boxShadow: "4px 4px 12px rgba(0,0,0,0.3)",width:mobile?"95%":"52%",height:"280px",padding:"16px"}}>
                  <Slider  {...rateSlider}>
                    {
                      rating.map((rate,indx)=>(
                        <div style={{height:"250px",boxShadow: "4px 4px 12px rgba(0,0,0,0.3)",borderRadius:"10px",margin:"15px",padding:"8px"}}>
                          
                          <div style={{display:"flex",padding:"15px",alignItems:"center",gap:"20px"}}>
                            <img src={rate.user.profileimg?`https://backend.shieldxsports.com/${rate.user.profileimg}`:'/asset/img/user-11.jpg'}
                            alt="img"
                            style={{width:"50px",height:"50px",borderRadius:"50%"}}
                            />
                          <p style={{fontSize:"20px",fontWeight:"500"}}>{rate.user.name}</p></div>


                          <p style={{display:"flex",alignItems:"center",paddingLeft:"16px"}}>
                            {
                              Array.from({ length: rate.rating }).map((_,i)=>
                               <img src={`/asset/img/star-fill.png`} style={{width:"20px"}}/>
                              )
                            }
                           
                          </p>
                          <p  style={{padding:"10px",borderLeft:"3px solid blue"}}>
                          {rate.review}
                          </p>
                        </div>
                      ))
                    }

                  </Slider>
                 </div>
                 :
                 <div style={{padding:"20px",width:"52%"}}>
                  <p style={{fontSize:"25px",fontWeight:"800",color: "gray"}}>No reviews available</p>
                 </div>
                 }

                </div>
                
                
                


                <SimilarProducts product={product} />
              </div>
            </div>
          </div>
        </div>
      </main>


      {isTeamModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "12px",
              width: "90%",
              // maxWidth: "500px"
            }}
          >
            <p style={{ marginTop: 0, marginBottom: "16px",fontWeight:600 ,fontSize:"20px"}}>
              Team Order Details
            </p>

            {productItems
              ?.filter((item) => item.product_id === product?.id)
              .map((item) => (
                <div key={item.product_id}>
                  <div
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <div
                      style={{
                        overflowX: "scroll",
                        overflowY:"scroll",
                        height:"fit-content",
                        maxHeight:"70vh",
                        width: "100%",
                        WebkitOverflowScrolling: "touch",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                      }}
                      className="w-full no-scrollbar"
                    >
                      <table
                        className="table-auto w-full border border-gray-300 m-auto"
                        style={{
                          position: "relative",
                          minWidth: "700px",
                          borderCollapse: "collapse",
                          width: "100%",
                          fontSize:mobile?"10":"20px"
                        }}
                      >
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="border border-gray-300  "  style={{ fontSize: mobile?"8px":"16px" }}>#</th>
                            <th
                              className="border border-gray-300  "
                              style={{ fontSize: mobile?"8px":"16px" }}
                            >
                              Size
                            </th>
                            {/* <th
                                className="border border-gray-300  "
                                style={{ fontSize: "16px" }}
                              >
                                Color
                              </th> */}
                            <th
                              className="border border-gray-300  "
                              style={{ fontSize: mobile?"8px":"16px" }}
                            >
                              Name
                            </th>
                            <th
                              className="border border-gray-300  "
                              style={{ fontSize: mobile?"8px":"16px" }}
                            >
                              Number
                            </th>

                            <th
                              className="border border-gray-300  "
                              style={{ fontSize:mobile?"8px": "16px" }}
                            >
                              Category
                            </th>

                            <th
                              className="border border-gray-300  "
                              style={{ fontSize: mobile?"8px":"16px" }}
                            >
                              Quantity
                            </th>
                            <th
                              className="border border-gray-300  "
                              style={{ fontSize:mobile?"8px": "16px" }}
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.data.map((size, rowIndex) => (
                            <tr key={size.id} className="hover:bg-gray-50"   style={{ fontSize: mobile?"8px":"16px" }}>
                              <td className="border border-gray-300  ">
                                {rowIndex + 1}
                              </td>
                              <td className="border border-gray-300" style={{maxWidth:mobile?"20px":"",padding:"2px"}}>
                                <select
                                 style={{maxWidth:mobile?"20px":"",padding:"2px",minWidth:mobile?"14px":""}}
                                  className="w-full bg-transparent text-gray-700 border border-gray-300 rounded-md"
                                  value={size.size_id || ""}
                                  onChange={(e) =>
                                    handleSizeChange(
                                      item.product_id,
                                      size.id,
                                      Number(e.target.value)
                                    )
                                  }
                                 
                                >
                                  <option value="">Select Size</option>
                                 
                                  {item.All_Size?.map((sizeOption) => (
                                    <option
                                      key={sizeOption.size_id}
                                      value={sizeOption.size_id}
                                    >
                                      {sizeOption.name}
                                    </option>
                                  ))}
                                </select>
                              </td>
                           
                              <td className="border border-gray-300  "   style={{maxWidth:mobile?"70px":"",padding:"2px"}}>
                                <input
                                  type="text"
                                    style={{ fontSize: mobile?"8px":"16px",padding:mobile?"2px":"8px",width:"fit-content",maxWidth:mobile?"70px":"" }}
                                  placeholder="Enter name"
                                  value={size.name || ""}
                                  onChange={(e) =>
                                    handleInputChange(
                                      item.product_id,
                                      size.id,
                                      "name",
                                      e.target.value
                                    )
                                  }
                                  className="w-full   bg-white text-black border border-gray-300 rounded-md"
                                />
                              </td>
                              <td className="border border-gray-300  ">
                                <input
                                  type="number"
                                    style={{ fontSize: mobile?"8px":"16px" }}
                                  placeholder="Enter jersey number"
                                  value={size.number || ""}
                                  onChange={(e) =>
                                    handleInputChange(
                                      item.product_id,
                                      size.id,
                                      "number",
                                      e.target.value
                                    )
                                  }
                                  className="w-full px-3  bg-white text-black border border-gray-300 rounded-md"
                                />
                              </td>
                              <td className="border border-gray-300  ">
                                <select
                                  className="w-full px-3  bg-transparent text-gray-700 border border-gray-300 rounded-md"
                                  value={size.category || ""}
                                  onChange={(e) =>
                                    handleInputChange(
                                      item.product_id,
                                      size.id,
                                      "category",
                                      e.target.value
                                    )
                                  }
                                >
                                  <option value="">Select Category</option>
                                  <option value="Men">Men</option>
                                  <option value="Women">Women</option>
                                  <option value="Kids">Kids</option>
                                </select>
                              </td>
                              <td className="border border-gray-300  ">
                                <div
                                  className="flex items-center gap-2 justify-center"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <button
                                    onClick={() =>
                                      handleDecrementProduct(
                                        item.product_id,
                                        size.id,
                                        size.qty
                                      )
                                    }
                                    style={{
                                      backgroundColor: "#003366",
                                      borderRadius: "10px",
                                    }}
                                    className="px-3 py-1 text-white rounded-md"
                                  >
                                    -
                                  </button>
                                  <span className="text-gray-700">
                                    {size.qty}
                                  </span>
                                  <button
                                    onClick={() =>
                                      handleIncrementProduct(
                                        item.product_id,
                                        size.id,
                                        size.qty
                                      )
                                    }
                                    style={{
                                      backgroundColor: "#003366",
                                      borderRadius: "10px",
                                    }}
                                    className="px-3 py-1 text-white rounded-md"
                                  >
                                    +
                                  </button>
                                </div>
                              </td>
                              <td className="border border-gray-300  ">
                                <div className="flex gap-2">
                                  <button
                                    onClick={() => {
                                      if (rowIndex === 0) {
                                        setDeleteTarget({
                                          cart_id: item.cart_id,
                                          data_id: size.id,
                                          type: "product", // Add type
                                        });
                                        setShowDeleteModal(true);
                                      } else {
                                        handleRemoveRowProduct(
                                          item.product_id,
                                          size.id
                                        );
                                      }
                                    }}
                                    className="px-3 py-1 text-white rounded-md"
                                    style={{ backgroundColor: "transparent" }}
                                  >
                                    <RiDeleteBin5Line
                                      style={{ color: "red" }}
                                    />
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleAddRowProduct(item.product_id, item)
                                    }
                                    className="px-3 py-1 text-white rounded-full"
                                    title="Add Row Below"
                                    style={{
                                      backgroundColor: "transparent",
                                    }}
                                  >
                                    <MdAdd
                                      style={{ color: "rgb(0, 51, 102)" }}
                                    />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}

                          {tempRows[item.cart_id]?.map((tempRow, index) => (
                            <tr key={tempRow.id} className="hover:bg-gray-50">
                              <td className="border border-gray-300  ">
                                {item.data.length + index + 1}
                              </td>
                              <td className="border border-gray-300  ">
                                <img
                                  src={`${baseAssetUrl}${item.image}`}
                                  alt="Product"
                                  width="50"
                                />
                              </td>
                              <td className="border border-gray-300  ">
                                <input
                                  type="text"
                                  placeholder="Enter name"
                                  value={tempRow.name}
                                  onChange={(e) =>
                                    handleTempRowChangeProduct(
                                      item.product_id,
                                      tempRow.id,
                                      "name",
                                      e.target.value
                                    )
                                  }
                                  className="w-full px-3  bg-white text-black border border-gray-300 rounded-md"
                                />
                              </td>
                              <td className="border border-gray-300  ">
                                <input
                                  type="number"
                                  placeholder="Enter jersey number"
                                  value={tempRow.number}
                                  onChange={(e) =>
                                    handleTempRowChangeProduct(
                                      item.product_id,
                                      tempRow.id,
                                      "number",
                                      e.target.value
                                    )
                                  }
                                  className="w-full px-3  bg-white text-black border border-gray-300 rounded-md"
                                />
                              </td>
                              <td className="border border-gray-300  ">
                                <select
                                  value={tempRow.size_id || ""}
                                  onChange={(e) =>
                                    handleTempRowChangeProduct(
                                      item.product_id,
                                      tempRow.id,
                                      "size_id",
                                      e.target.value
                                    )
                                  }
                                  className="w-full px-3  bg-transparent text-gray-700 border border-gray-300 rounded-md"
                                >
                                  <option value="">Select Size</option>
                                  {sizeAll?.map((sizeOption) => (
                                    <option
                                      key={sizeOption.id}
                                      value={sizeOption.id}
                                    >
                                      {sizeOption.name}
                                    </option>
                                  ))}
                                </select>
                              </td>
                              <td className="border border-gray-300  ">
                                <div className="flex items-center gap-2 justify-center">
                                  <button
                                    style={{
                                      backgroundColor: "#003366",
                                      borderRadius: "10px",
                                    }}
                                    onClick={() =>
                                      handleTempRowChangeProduct(
                                        item.product_id,
                                        tempRow.id,
                                        "qty",
                                        tempRow.qty > 1 ? tempRow.qty - 1 : 1
                                      )
                                    }
                                    className="px-3 py-1 text-white rounded-md"
                                  >
                                    -
                                  </button>
                                  <span className="text-gray-700">
                                    {tempRow.qty}
                                  </span>
                                  <button
                                    style={{
                                      backgroundColor: "#003366",
                                      borderRadius: "10px",
                                    }}
                                    onClick={() =>
                                      handleTempRowChangeProduct(
                                        item.product_id,
                                        tempRow.id,
                                        "qty",
                                        tempRow.qty + 1
                                      )
                                    }
                                    className="px-3 py-1 text-white rounded-md"
                                  >
                                    +
                                  </button>
                                </div>
                              </td>
                              <td className="border border-gray-300  ">
                                <button
                                  onClick={() =>
                                    handleRemoveTempRow(
                                      item.product_id,
                                      tempRow.id
                                    )
                                  }
                                  className="px-3 py-1 text-white rounded-md"
                                  style={{
                                    backgroundColor: "transparent",
                                  }}
                                >
                                  <RiDeleteBin5Line style={{ color: "red" }} />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ))}

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
                marginTop: "17px",
              }}
            >
              <button
                onClick={() => {
                  setIsTeamModalOpen(false);
                  // setOrderType("normal");
                }}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#ef4444",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                onClick={async() => {
                  const p=cart.productItems.find((i)=>i.product_id===product.id)

                 await p.data.forEach(ele => {
                    if(ele.name==="" || ele.number==="" ){
                      toast.info("Please fill all the details in team order")
                      setIsTeamModalOpen(true);
                      return
                    }else{
                        setOrderType("team");
                  dispatch(
                    setProductOrderType({
                      product_id: product?.id,
                      orderType: "team",
                    })
                  );
                   setIsTeamModalOpen(false);
                    }
                  });
                 
                
               
                  
                }}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#2f4efcff",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Family Order Modal */}
      {isFamilyModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "12px",
              width: "90%",
            }}
          >
            <h3 style={{ marginTop: 0, marginBottom: "16px" }}>
              Family Order Details
            </h3>

            {productItems
              ?.filter((item) => item.product_id === product?.id)
              .map((item) => (
                <div key={item.product_id}>
                  <div
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <div
                      style={{
                        overflowX: "auto",
                        width: "100%",
                        WebkitOverflowScrolling: "touch",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                      }}
                      className="w-full no-scrollbar"
                    >
                      <table
                        className="table-auto w-full border border-gray-300 m-auto"
                        style={{
                          position: "relative",
                          minWidth: "700px",
                          borderCollapse: "collapse",
                          width: "100%",
                        }}
                      >
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="border border-gray-300  ">#</th>
                            <th
                              className="border border-gray-300  "
                              style={{ fontSize: "16px" }}
                            >
                              Size
                            </th>
                            {/* <th
                                className="border border-gray-300  "
                                style={{ fontSize: "16px" }}
                              >
                                Color
                              </th> */}
                            <th
                              className="border border-gray-300  "
                              style={{ fontSize: "16px" }}
                            >
                              Name
                            </th>
                            <th
                              className="border border-gray-300  "
                              style={{ fontSize: "16px" }}
                            >
                              Number
                            </th>

                            <th
                              className="border border-gray-300  "
                              style={{ fontSize: "16px" }}
                            >
                              Category
                            </th>

                            <th
                              className="border border-gray-300  "
                              style={{ fontSize: "16px" }}
                            >
                              Quantity
                            </th>
                            <th
                              className="border border-gray-300  "
                              style={{ fontSize: "16px" }}
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.data.map((size, rowIndex) => (
                            <tr key={size.id} className="hover:bg-gray-50">
                              <td className="border border-gray-300  ">
                                {rowIndex + 1}
                              </td>
                              <td className="border border-gray-300  ">
                                <select
                                  className="w-full px-3  bg-transparent text-gray-700 border border-gray-300 rounded-md"
                                  value={size.size_id || ""}
                                  onChange={(e) =>
                                    handleSizeChange(
                                      item.product_id,
                                      size.id,
                                      Number(e.target.value)
                                    )
                                  }
                                >
                                  <option value="">Select Size</option>
                                  {/* {sizeAll?.map((sizeOption) => (
                                      <option
                                        key={sizeOption.id}
                                        value={sizeOption.id}
                                      >
                                        {sizeOption.name}
                                      </option>
                                    ))} */}
                                  {item.All_Size?.map((sizeOption) => (
                                    <option
                                      key={sizeOption.size_id}
                                      value={sizeOption.size_id}
                                    >
                                      {sizeOption.name}
                                    </option>
                                  ))}
                                </select>
                              </td>
                              {/* <td className="border border-gray-300  ">
                                  <select
                                    className="w-full px-3  bg-transparent text-gray-700 border border-gray-300 rounded-md"
                                    value={size.color_id || ""}
                                    onChange={(e) =>
                                      handleColorChange(
                                        item.product_id,
                                        size.id,
                                        Number(e.target.value)
                                      )
                                    }
                                  >
                                    <option value="">Select Color</option>
                                    {item.All_Color?.map((colorOption) => (
                                      <option
                                        key={colorOption.color_id}
                                        value={colorOption.color_id}
                                      >
                                        {colorOption.name}
                                      </option>
                                    ))}
                                  </select>
                                </td> */}
                              <td className="border border-gray-300  ">
                                <input
                                  type="text"
                                  placeholder="Enter name"
                                  value={size.name || ""}
                                  onChange={(e) =>
                                    handleInputChange(
                                      item.product_id,
                                      size.id,
                                      "name",
                                      e.target.value
                                    )
                                  }
                                  className="w-full px-3  bg-white text-black border border-gray-300 rounded-md"
                                />
                              </td>
                              <td className="border border-gray-300  ">
                                <input
                                  type="number"
                                  placeholder="Enter jersey number"
                                  value={size.number || ""}
                                  onChange={(e) =>
                                    handleInputChange(
                                      item.product_id,
                                      size.id,
                                      "number",
                                      e.target.value
                                    )
                                  }
                                  className="w-full px-3  bg-white text-black border border-gray-300 rounded-md"
                                />
                              </td>
                              <td className="border border-gray-300  ">
                                <select
                                  className="w-full px-3  bg-transparent text-gray-700 border border-gray-300 rounded-md"
                                  value={size.category || ""}
                                  onChange={(e) =>
                                    handleInputChange(
                                      item.product_id,
                                      size.id,
                                      "category",
                                      e.target.value
                                    )
                                  }
                                >
                                  <option value="">Select Category</option>
                                  <option value="Men">Men</option>
                                  <option value="Women">Women</option>
                                  <option value="Kids">Kids</option>
                                </select>
                              </td>
                              <td className="border border-gray-300  ">
                                <div
                                  className="flex items-center gap-2 justify-center"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <button
                                    onClick={() =>
                                      handleDecrementProduct(
                                        item.product_id,
                                        size.id,
                                        size.qty
                                      )
                                    }
                                    style={{
                                      backgroundColor: "#003366",
                                      borderRadius: "10px",
                                    }}
                                    className="px-3 py-1 text-white rounded-md"
                                  >
                                    -
                                  </button>
                                  <span className="text-gray-700">
                                    {size.qty}
                                  </span>
                                  <button
                                    onClick={() =>
                                      handleIncrementProduct(
                                        item.product_id,
                                        size.id,
                                        size.qty
                                      )
                                    }
                                    style={{
                                      backgroundColor: "#003366",
                                      borderRadius: "10px",
                                    }}
                                    className="px-3 py-1 text-white rounded-md"
                                  >
                                    +
                                  </button>
                                </div>
                              </td>
                              <td className="border border-gray-300  ">
                                <div className="flex gap-2">
                                  <button
                                    onClick={() => {
                                      if (rowIndex === 0) {
                                        setDeleteTarget({
                                          cart_id: item.cart_id,
                                          data_id: size.id,
                                          type: "product", // Add type
                                        });
                                        setShowDeleteModal(true);
                                      } else {
                                        handleRemoveRowProduct(
                                          item.product_id,
                                          size.id
                                        );
                                      }
                                    }}
                                    className="px-3 py-1 text-white rounded-md"
                                    style={{ backgroundColor: "transparent" }}
                                  >
                                    <RiDeleteBin5Line
                                      style={{ color: "red" }}
                                    />
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleAddRowProduct(item.product_id, item)
                                    }
                                    className="px-3 py-1 text-white rounded-full"
                                    title="Add Row Below"
                                    style={{
                                      backgroundColor: "transparent",
                                    }}
                                  >
                                    <MdAdd
                                      style={{ color: "rgb(0, 51, 102)" }}
                                    />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}

                          {tempRows[item.cart_id]?.map((tempRow, index) => (
                            <tr key={tempRow.id} className="hover:bg-gray-50">
                              <td className="border border-gray-300  ">
                                {item.data.length + index + 1}
                              </td>
                              <td className="border border-gray-300  ">
                                <img
                                  src={`${baseAssetUrl}${item.image}`}
                                  alt="Product"
                                  width="50"
                                />
                              </td>
                              <td className="border border-gray-300  ">
                                <input
                                  type="text"
                                  placeholder="Enter name"
                                  value={tempRow.name}
                                  onChange={(e) =>
                                    handleTempRowChangeProduct(
                                      item.product_id,
                                      tempRow.id,
                                      "name",
                                      e.target.value
                                    )
                                  }
                                  className="w-full px-3  bg-white text-black border border-gray-300 rounded-md"
                                />
                              </td>
                              <td className="border border-gray-300  ">
                                <input
                                  type="number"
                                  placeholder="Enter jersey number"
                                  value={tempRow.number}
                                  onChange={(e) =>
                                    handleTempRowChangeProduct(
                                      item.product_id,
                                      tempRow.id,
                                      "number",
                                      e.target.value
                                    )
                                  }
                                  className="w-full px-3  bg-white text-black border border-gray-300 rounded-md"
                                />
                              </td>
                              <td className="border border-gray-300  ">
                                <select
                                  value={tempRow.size_id || ""}
                                  onChange={(e) =>
                                    handleTempRowChangeProduct(
                                      item.product_id,
                                      tempRow.id,
                                      "size_id",
                                      e.target.value
                                    )
                                  }
                                  className="w-full px-3  bg-transparent text-gray-700 border border-gray-300 rounded-md"
                                >
                                  <option value="">Select Size</option>
                                  {sizeAll?.map((sizeOption) => (
                                    <option
                                      key={sizeOption.id}
                                      value={sizeOption.id}
                                    >
                                      {sizeOption.name}
                                    </option>
                                  ))}
                                </select>
                              </td>
                              <td className="border border-gray-300  ">
                                <div className="flex items-center gap-2 justify-center">
                                  <button
                                    style={{
                                      backgroundColor: "#003366",
                                      borderRadius: "10px",
                                    }}
                                    onClick={() =>
                                      handleTempRowChangeProduct(
                                        item.product_id,
                                        tempRow.id,
                                        "qty",
                                        tempRow.qty > 1 ? tempRow.qty - 1 : 1
                                      )
                                    }
                                    className="px-3 py-1 text-white rounded-md"
                                  >
                                    -
                                  </button>
                                  <span className="text-gray-700">
                                    {tempRow.qty}
                                  </span>
                                  <button
                                    style={{
                                      backgroundColor: "#003366",
                                      borderRadius: "10px",
                                    }}
                                    onClick={() =>
                                      handleTempRowChangeProduct(
                                        item.product_id,
                                        tempRow.id,
                                        "qty",
                                        tempRow.qty + 1
                                      )
                                    }
                                    className="px-3 py-1 text-white rounded-md"
                                  >
                                    +
                                  </button>
                                </div>
                              </td>
                              <td className="border border-gray-300  ">
                                <button
                                  onClick={() =>
                                    handleRemoveTempRow(
                                      item.product_id,
                                      tempRow.id
                                    )
                                  }
                                  className="px-3 py-1 text-white rounded-md"
                                  style={{
                                    backgroundColor: "transparent",
                                  }}
                                >
                                  <RiDeleteBin5Line style={{ color: "red" }} />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ))}

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
                marginTop: "17px",
              }}
            >
              <button
                onClick={() => {
                  setIsFamilyModalOpen(false);
                  // setOrderType("normal");
                }}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#ef4444",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                    onClick={async() => {
                  const p=cart.productItems.find((i)=>i.product_id===product.id)

                 await p.data.forEach(ele => {
                    if(ele.name==="" || ele.number==="" ){
                      toast.info("Please fill all the details in family order")
                      setIsTeamModalOpen(true);
                      return
                    }else{
                      setIsFamilyModalOpen(false);
                  setOrderType("family");
                  dispatch(
                    setProductOrderType({
                      product_id: product?.id,
                      orderType: "family",
                    })
                  );
                    }
                  });
                 
                              
                }}
               
             
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#3b82f6",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}

export default DetailsPage;
